<template>
  <!-- R2 版本 删除部分内容， 原有文件见 IndexOld.vue -->
  <!-- 共享资料库、员工资料库 -->
  <div class="project-table" id="project-table">
    <div class="content--options" id="content--options">
      <div class="list">
        <!-- 按钮组 -->
        <operation-buttons
          :button-list="buttonList"
          @uploadHandle="upload"
          @clickHandle="topButtonClick"
          class="float_left">
        </operation-buttons>
        <!-- 列表/缩略图 切换 -->
        <operation-module-type
          v-show="!showFileListOfShare"
          :current-sort="sortFieldName + ',' + sortType"
          @change="moduleTypeQueryList"
          class="float_right"
          :selectedType="typeFilterData">
        </operation-module-type>
        <!-- 搜索 -->
        <operation-search
          ref="operationSearch"
          v-if="tabletype !== 'projectList'"
          class="float_right margin-left-10"
          @onSearch="searchHandle"></operation-search>
        <!-- 文件类型筛选 checked="amountFile" -->
        <!--<operation-file-type @change="typeQueryList" class="float_right" :checked="fileType"></operation-file-type>-->
      </div>
      <div class="list">
        <!-- 面包屑 -->
        <operation-crumb class="flex-1" :items="pathItems" :search-value="searchVal"
                         @change="queryPathList"></operation-crumb>
      </div>
    </div>
    <div class="dndCnt" id="dndCnt" :class="{dndCntShow: drawFileShow && !showFileListOfShare}">
      <div class="dnd-hintbox">
        <i></i>可将文件拖拽到框内任意区域
      </div>
      <!-- 展示 其他文件列表 -->
      <div class="tabcnt" id="projectTabCnt">
        <!-- 展示 我收到的分享工程文件列表 -->
        <template v-if="showFileListOfShare">
          <Table :height="tableHeight" :fixedTable="true"
                 :showNoData="dataList.length === 0"
                 no-data-text="还没有收到工程文件">
            <thead slot="header">
            <tr>
              <th width="240" class="checkAllth">
                <label class="checkall-label">
                  <!--<input type="checkbox" @change="checkAll" :checked="isCheckAll"/> 全选-->
                  <w-checkbox @change="checkAll" v-model="isCheckAll"></w-checkbox>
                </label>
                <span class="check-length" v-if="checkedLen > 0">
                  <span>
                    已选中{{checkedLen}}项
                  </span>
                </span>
                <span class="person-sort" v-else>
                    名称
                  </span>
              </th>
              <!--<th width="120">类型</th>-->
              <!--<th width="60">地区</th>-->
              <th width="80">分享时间</th>
              <th width="120" v-if="user.role === 5">剩余时间</th>
              <th width="120" v-if="user.role !== 5">分享人</th>
              <th width="80">
                文件大小
              </th>
              <th class="is-operate" width="80"></th>
            </tr>
            </thead>
            <tbody slot="body">
            <tr v-for="(item,index) in dataList"
                :key="'tr_' + index + refreshIndex"
                height="40"
                :id="item.fileId"
                @click="trClick(index, item)"
                :class="['trItem', item.checked ? 'active trItem' : '']"
                @mouseenter="trMouseEnter(item, index)"
                @mouseleave="trMouseLeave(item)">
              <td width="240">
                <div class="l-boxd">
                  <label class="w__checkbox" style="margin-right: 0;"
                         :class="{'is-checked': item.checked}"
                         :style="{visibility: item.fileType !== 'share' ? 'visible' : 'hidden'}">
                    <span class="w__checkbox__input" :class="{'is-checked': item.checked}">
                      <span class="w__checkbox__inner" @click.stop.prevent="trClick(index, item)"></span>
                      <input type="checkbox" class="w__checkbox__original" value="">
                    </span>
                  </label>
                  <div class="personHover l-boxd-d icon-name_cont">
                    <i
                      :class="['file-icons', item.invalid ? 'icon_invalid' : 'icon_' + item.suffix + ' icon_' + item.projectType]"
                      @click.stop="nameClick(item)">
                    </i>
                    <span class="file-name" v-on:click.stop="nameClick(item)" :title="item.fileName">
                      {{item.fileName}}
                    </span>
                    <span class="invalid_flag" v-if="item.invalid">
                      已失效
                    </span>
                    <w-tag style="color: rgba(33,37,48,0.55);border-color: rgba(222,223,224,1);" class="margin-left-10"
                           size="mini" around v-if="item.fileType == 1 && item.region">{{item.region}}
                    </w-tag>
                  </div>
                </div>
              </td>
              <!--<td width="120" align="center">-->
              <!--{{getFileTypeName(item)}}-->
              <!--</td>-->
              <!--<td width="60" align="center">-->
              <!--{{item.region}}-->
              <!--</td>-->
              <td width="80">
                {{item.shareTimeStr}}
              </td>
              <td width="120" v-if="user.role === 5">
                <!-- 个人账号展示 剩余时间 -->
                {{item.remainTimeStr}}
              </td>
              <td width="120" v-if="user.role !== 5">
                {{item.shareLink ? '链接分享' : item.authorAccount}}
              </td>
              <td width="80">
                {{item.size}}
              </td>
              <td width="80" class="is-operate" :key="index + '_icon_' + iconListKey">
                <div v-if="!item.isCreateFolder  && item.fileType !== 'share'" class="operation operation_cont">
                  <template
                    v-if="!item.isEncrypt && item.canPreview && iconListKey && previewIcon[capitalize(item.suffix)] && previewIcon[capitalize(item.suffix)].suffix">
                    <el-tooltip :content="previewIcon[capitalize(item.suffix)].name">
                      <a @click.stop="shareFileActionEmitter('preview', item)"
                         :class="['preview-icon w-icon-' + previewIcon[capitalize(item.suffix)].icon, item.invalid ? 'invalid' : '']">
                        <!--预览 .gbq5 文件-->
                      </a>
                    </el-tooltip>
                    <el-tooltip content="下载">
                      <a :class="['w-icon-xiazai1', item.invalid ? 'invalid' : '']"
                         v-on:click.stop="shareFileActionEmitter('download', item)">
                      </a>
                    </el-tooltip>
                    <w-dropdown @command="handlerActionByRow">
                      <span class="w__dropdown-link">
                       <span class="more"><i class="r2-icon-nav_more_vert" style="font-size: 16px !important;"></i>
                       </span>
                      </span>
                      <w-dropdown-menu slot="dropdown">
                        <w-dropdown-item :command="{item, fn: 'deleteFiles'}">删除</w-dropdown-item>
                        <w-dropdown-item :command="{item, fn: 'saveShareFile'}">转存到我的空间</w-dropdown-item>
                      </w-dropdown-menu>
                    </w-dropdown>
                  </template>
                  <template v-else>
                    <el-tooltip content="下载">
                      <a :class="['w-icon-xiazai1', item.invalid ? 'invalid' : '']"
                         v-on:click.stop="shareFileActionEmitter('download', item)">
                      </a>
                    </el-tooltip>
                    <el-tooltip content="删除">
                      <a class="r2-icon-action_delete_outline"
                         v-on:click.stop="deleteFiles(item)">
                      </a>
                    </el-tooltip>
                    <el-tooltip content="转存到我的空间">
                      <a :class="['w-icon-fuzhidaoqiyekongjian', item.invalid ? 'invalid' : '']"
                         v-on:click.stop="saveShareFile(item)">
                      </a>
                    </el-tooltip>
                  </template>
                </div>
              </td>
            </tr>
            </tbody>
          </Table>
        </template>
        <!-- 展示 其他工程文件列表 -->
        <template v-else>
          <Table v-if="typeFilterData === 'list'"
                 :height="tableHeight"
                 :fixedTable="true"
                 :showNoData="dataList.length === 0"
                 no-data-text="还没有上传文件"
                 v-loading="loading"
                 element-loading-background="rgba(255, 255, 255, 0.8)">
            <thead slot="header">
            <tr>
              <th width="240" class="checkAllth">
                <label class="checkall-label">
                  <!--<input type="checkbox" @change="checkAll" :checked="isCheckAll"/> 全选-->
                  <w-checkbox @change="checkAll" v-model="isCheckAll"></w-checkbox>
                </label>
                <span class="check-length" v-if="checkedLen > 0">
                   <span>已选中{{checkedLen}}项</span>
                  <!--<span>已选中{{checkedLen}}个文件/文件夹</span>-->
                  </span>
                <span class="person-sort" @click="sortClick('name_chn')" v-else>
                    名称
                    <i class="sort" v-if="sortFieldName !== 'name_chn'"></i>
                    <i class="sort" v-else :class="+sortType === 1 ? 'sort-down': 'sort-up'"></i>
                  </span>
              </th>
              <th width="120" v-if="searchVal && !loading">所在目录</th>
              <!--<th width="120" v-if="tabletype !== 'companyList'">类型</th>-->
              <!--<th width="60" v-if="tabletype !== 'companyList'">地区</th>-->
              <th width="80"
                  class="break-all text-align-left"
                  v-if="(tabletype === 'companyList') || tabletype === 'projectList'">
                创建人
                <!--{{tabletype === 'companyList' ? '上传者' : '编制人'}}-->
              </th>
              <th width="80">
                      <span class="person-sort" @click="sortClick('modifiedTime')">
                        修改时间
                        <i class="sort" v-if="sortFieldName !== 'modifiedTime'"></i>
                        <i class="sort" v-else :class="+sortType === 1 ? 'sort-down': 'sort-up'"></i>
                      </span>
              </th>
              <th width="80">{{tabletype === 'companyList' ? '上传时间' : '创建时间'}}</th>
              <th width="55">
                  <span class="person-sort" @click="sortClick('size')">
                    文件大小
                    <i class="sort" v-if="sortFieldName !== 'size'"></i>
                    <i class="sort" v-else :class="+sortType === 1 ? 'sort-down': 'sort-up'"></i>
                  </span>
              </th>
              <th width="60" class="is-operate">操作</th>
            </tr>
            </thead>
            <tbody slot="body" :class="{jiliangTab: +fileType === 2, size_96: +fileType === 2}">
            <!-- 新手引导相关页面结构 R2 第一迭代 先删掉 -->
            <tr v-for="(item,index) in dataList"
                :key="'tr_' + index + refreshIndex"
                height="40"
                :id="item.fileId"
                @click="trClick(index, item)"
                :class="['trItem',  item.checked ? 'active trItem' : '', item.fileType === 'share' ? 'nohoverclass' : '']"
                @mouseenter="trMouseEnter(item, index)"
                @mouseleave="trMouseLeave(item)"
            >
              <td width="240">
                <div class="l-boxd">
                  <input v-if="item.fileProperties && isGTJXT(item)" type="checkbox" style="visibility:hidden;"/>
                  <!--<input v-else type="checkbox" :style="{visibility: item.fileType !== 'share' ? 'visible' : 'hidden'}"-->
                  <!--:checked="item.checked"-->
                  <!--@click.stop="checkboxTap(item, index, $event)"/>-->
                  <label class="w__checkbox" style="margin-right: 0;"
                         :class="{'is-checked': item.checked}"
                         :style="{visibility: item.fileType !== 'share' ? 'visible' : 'hidden'}">
                    <span class="w__checkbox__input" :class="{'is-checked': item.checked}">
                      <span class="w__checkbox__inner" @click.stop.prevent="trClick(index, item)"></span>
                      <input type="checkbox" class="w__checkbox__original" value="">
                    </span>
                  </label>
                  <div class="personHover l-boxd-d">
                    <template
                      v-if="tabletype!=='projectList' && item && item.suffix && (item.suffix + '').toUpperCase() === 'GTJXT'">
                      <i
                        :class="['file-icons', 'icon_' + item.fileProperties.projectType, item.folder ? (item.fileType === 'share' ? 'folder__share' : 'folder') : '']"
                        @mouseenter="personTextBoxStyleHandle(index);"
                        @mouseleave="iconHoverIndex =-1"
                        @click.stop="nameClick(item)"
                      ></i>
                    </template>
                    <template v-else-if="item.thumbnailUrl && +fileType == 2">
                      <img
                        :src="item.thumbnailUrl"
                        @mouseenter="personTextBoxStyleHandle(index);"
                        @mouseleave="iconHoverIndex = -1"
                        @click.stop="nameClick(item)"
                      />
                    </template>
                    <template v-else>
                      <i
                        :class="['file-icons', tabletype !== 'projectList' && (item.suffix==='gtjxt'||item.suffix==='GTJXT')? 'icon_':'icon_' + item.suffix,isGTJXT(item)?'icon_10000':'', 'icon_' + item.fileProperties.projectType, item.folder ? (item.fileType === 'share' ? 'folder__share' : 'folder') : '']"
                        @mouseenter="personTextBoxStyleHandle(index);"
                        @mouseleave="iconHoverIndex = -1"
                        @click.stop="nameClick(item)"
                      ></i>
                    </template>
                    <span
                      v-if="renameData.showIndex !== index"
                      class="file-name"
                      v-on:click.stop="nameClick(item)"
                      v-on:dblclick.stop="fileRename(index, item.name, 'dbClick', item)"
                      :title="item.name">
                      {{item.name}}
                    </span>
                    <w-tag style="color: rgba(33,37,48,0.55);border-color: rgba(222,223,224,1);" class="margin-left-10"
                           size="mini" around
                           v-if="item.fileType == 1 && item.fileProperties.region && renameData.showIndex !== index">
                      {{item.fileProperties.region}}
                    </w-tag>
                    <div class="w-rename" v-if="renameData.showIndex === index">
                      <w-input size="small" autofocus v-model="renameData.value" @blur="handleRenameBlur(item)"
                               @click.stop="" input-class-name="renameInput"></w-input>
                      <!--<i-->
                      <!--class="w-icon-tijiao w-rename&#45;&#45;ok"-->
                      <!--v-on:click.stop="fileRenameSuccess(item)"-->
                      <!--&gt;</i>-->
                      <!--<i-->
                      <!--class="w-icon-quxiao2 w-rename&#45;&#45;cancel"-->
                      <!--v-on:click.stop="fileRenameCancel(item)"-->
                      <!--&gt;</i>-->
                    </div>
                    <div v-if="!item.folder" class="person-textbox" v-show="iconHoverIndex === index">
                      <p>创建时间：{{item.createTime}}</p>
                      <p>文件大小：{{item.size}}</p>
                      <p v-if="tabletype=='projectList'">编制人：{{item.originalCreatorName}}</p>
                      <template v-if="+item.fileType == 1">
                        <p>
                          文件类型：
                          <template v-if="+item.extraInfo === 1">概算</template>
                          <template v-else-if="+item.extraInfo === 2">预算</template>
                          <template v-else-if="+item.extraInfo === 3">结算</template>
                          <template v-else>审核</template>
                        </p>
                      </template>
                      <template v-if="+item.fileType == 2">
                        <p>
                          <label>工程类别：</label>
                          {{item.fileProperties.projectCategory || '【无】'}}
                        </p>
                        <p>
                          <label>结构类型：</label>
                          {{item.fileProperties.structureCategory || '【无】'}}
                        </p>
                        <p>
                          <label>清单规则：</label>
                          {{item.fileProperties.listRule || '【无】'}}
                        </p>
                        <p>
                          <label>定额规则：</label>
                          {{item.fileProperties.quotaRule || '【无】'}}
                        </p>
                      </template>
                    </div>
                  </div>
                </div>
              </td>
              <td width="120" v-if="searchVal && !loading">
                <a class="file-directory" @click.stop="handleDirectoryClick(item)">{{item.path |
                  lastLevelDirectory}}</a>
              </td>
              <!--<td width="120" align="center" v-if="tabletype !== 'companyList'">{{getFileTypeName(item)}}</td>-->
              <!--<td width="60" align="center" v-if="tabletype !== 'companyList'">{{item.fileProperties.region}}</td>-->
              <td width="80" class="break-all"
                  v-if="(tabletype === 'companyList') || tabletype === 'projectList'">
                {{item.originalCreatorName}}
                <!--{{item.folder ? "" : item.originalCreatorName}}-->
              </td>
              <td width="80">{{item.modifyTime}}</td>
              <td width="80">{{item.createTime}}</td>
              <td width="55">{{item.folder ? '' : item.size}}</td>
              <td width="60" class="is-operate" :class="[!item.permission && !item.folder ? 'no-permission' : '',]" :key="index + '_icon_' + iconListKey">
                <div v-if="isGTJXT(item)" class="operation operation_cont">
                  <el-tooltip content="协同建模">
                    <a class="w-icon-xietongjianmo" v-on:click.stop="goGTJXTModel(item)"></a>
                  </el-tooltip>
                  <template
                    v-if="iconListKey && previewIcon[capitalize('GTJ')] && previewIcon[capitalize('GTJ')].suffix">
                    <el-tooltip :content="previewIcon[capitalize('GTJ')].name">
                      <a @click.stop="previewgtjxt(item)"
                         :class="['preview-icon w-icon-' + previewIcon[capitalize('GTJ')].icon]">
                      </a>
                    </el-tooltip>
                  </template>
                </div>
                <div v-else-if="!item.isCreateFolder  && item.fileType !== 'share'" class="operation operation_cont">
                  <!--操作列，最多显示三个操作按钮，多余部分三个点下拉菜单显示-->
                  <template
                    v-if="iconListKey && previewIcon[capitalize(item.suffix)] && previewIcon[capitalize(item.suffix)].suffix && judgeShare(item.suffix) && ((tabletype !== 'companyList' && item.permission) || (tabletype === 'companyList' && (isModuleAdmin || (!isModuleAdmin && permission))))">
                    <!--当有预览按钮，且有删除时，按钮总数大于3时，才会省略显示-->
                    <template
                      v-if="iconListKey && previewIcon[capitalize(item.suffix)] && previewIcon[capitalize(item.suffix)].suffix">
                      <el-tooltip :content="previewIcon[capitalize(item.suffix)].name">
                        <a @click.stop="previewHandle(item, previewIcon[capitalize(item.suffix)], 2)"
                           :class="['preview-icon w-icon-' + previewIcon[capitalize(item.suffix)].icon]">
                          <!--预览 .gbq5 文件-->
                        </a>
                      </el-tooltip>
                    </template>
                    <el-tooltip content="分享" v-if="judgeShare(item.suffix)">
                      <a class="r2-icon-social_share" v-on:click.stop="shareFile(item)"></a>
                    </el-tooltip>
                    <w-dropdown @command="handlerActionByRow">
                      <span class="w__dropdown-link">
                       <span class="more"><i class="r2-icon-nav_more_vert" style="font-size: 16px !important;"></i>
                       </span>
                      </span>
                      <w-dropdown-menu slot="dropdown">
                        <w-dropdown-item :command="{item, fn: 'downloadFile'}">下载</w-dropdown-item>
                        <w-dropdown-item :command="{item, fn: 'deleteFiles'}">删除</w-dropdown-item>
                      </w-dropdown-menu>
                    </w-dropdown>
                  </template>
                  <template v-else>
                    <!--原有逻辑-->
                    <template
                      v-if="iconListKey && previewIcon[capitalize(item.suffix)] && previewIcon[capitalize(item.suffix)].suffix">
                      <el-tooltip :content="previewIcon[capitalize(item.suffix)].name">
                        <a @click.stop="previewHandle(item, previewIcon[capitalize(item.suffix)], 2)"
                           :class="['preview-icon w-icon-' + previewIcon[capitalize(item.suffix)].icon]">
                          <!--预览 .gbq5 文件-->
                        </a>
                      </el-tooltip>
                    </template>
                    <el-tooltip content="分享" v-if="judgeShare(item.suffix)">
                      <a class="r2-icon-social_share" v-on:click.stop="shareFile(item)"></a>
                    </el-tooltip>
                    <el-tooltip content="下载">
                      <a class="w-icon-xiazai1" v-on:click.stop="downloadFile(item)"></a>
                    </el-tooltip>
                    <!-- 有权限时 才显示已下按钮 -->
                    <template v-if="tabletype!='companyList' && item.permission">
                      <el-tooltip content="删除">
                        <a class="r2-icon-action_delete_outline" v-on:click.stop="deleteFiles(item)"></a>
                      </el-tooltip>
                    </template>
                    <!--<template v-else-if="+user.userType === 1">-->
                    <template
                      v-else-if="tabletype === 'companyList' && (isModuleAdmin || (!isModuleAdmin && permission))">
                      <el-tooltip content="删除">
                        <a class="r2-icon-action_delete_outline" v-on:click.stop="deleteFiles(item)"></a>
                      </el-tooltip>
                    </template>
                  </template>
                </div>
              </td>
            </tr>
            </tbody>
          </Table>
          <div v-else class="listcnt" :style="{height: tableHeight + 50 + 'px'}">
            <div class="imgItem-checkall">
              <label class="checkall-label">
                <!--<input type="checkbox" @change="checkAll" :checked="isCheckAll"/> 全选-->
                <w-checkbox @change="checkAll" v-model="isCheckAll">全选</w-checkbox>
              </label>
              <!--<span class="check-length">-->
              <!--<span v-if="checkedLen > 0">已选中{{checkedLen}}个文件/文件夹</span>-->
              <!--</span>-->
            </div>
            <div
              class="size_96 thumbnail-item relative"
              :class="[item.checked ? 'active trItem imgItem' : 'trItem imgItem', !item.permission && !item.folder ? 'no-permission' : '', isGTJXT(item)?'nohoverclass' : '', item.fileType === 'share' ? 'nohoverclass' : '']"
              v-for="(item,index) in dataList"
              :id="item.fileId"
              :key="'tr_' + index + refreshIndex"
              @mouseenter="trMouseEnter(item,index)"
              @mouseleave="trMouseLeave(item)"
            >
              <div class="absolute more" style="right: 5px; top: 2px;z-index: 9;">
                <w-dropdown @command="handlerAction" trigger="click">
                    <span class="w__dropdown-link" @click.stop="_clickHandle(item, index)">
                       <span class="more"><i class="r2-icon-nav_more_vert"
                                             style="font-size: 16px !important;"></i></span>
                    </span>
                  <w-dropdown-menu :visibleArrow="false" slot="dropdown">
                    <template v-if="isGTJXT(nowPreview.item)">
                      <!-- 我收到的分享工程 文件夹内 右键菜单 -->
                      <w-dropdown-item :command="{item, fn: 'contextmenuClick', type: 'viewModel'}">查看模型
                      </w-dropdown-item>
                      <w-dropdown-item :command="{item, fn: 'contextmenuClick', type: 'gtjxtmodel'}">协同建模
                      </w-dropdown-item>
                    </template>
                    <template v-else-if="showFileListOfShare">
                      <!-- 我收到的分享工程 文件夹内 右键菜单 -->
                      <w-dropdown-item :disabled="contextMenuDisable.viewModel"
                                       :command="{item, fn: 'contextmenuClick', type: 'viewModel'}">
                        查看模型
                      </w-dropdown-item>
                      <w-dropdown-item :disabled="contextMenuDisable.preview"
                                       :command="{item, fn: 'contextmenuClick', type: 'preview'}">预览
                      </w-dropdown-item>
                      <w-dropdown-item :disabled="contextMenuDisable.download"
                                       :command="{item, fn: 'contextmenuClick', type: 'download'}">下载
                      </w-dropdown-item>
                      <w-dropdown-item :disabled="contextMenuDisable.unloading"
                                       :command="{item, fn: 'contextmenuClick', type: 'unloading'}">转存到我的空间
                      </w-dropdown-item>
                      <w-dropdown-item :command="{item, fn: 'contextmenuClick', type: 'delete'}">删除</w-dropdown-item>
                    </template>
                    <template v-else>
                      <w-dropdown-item :disabled="contextMenuDisable.viewModel"
                                       :command="{item, fn: 'contextmenuClick', type: 'viewModel'}">查看模型
                      </w-dropdown-item>
                      <w-dropdown-item :disabled="contextMenuDisable.preview"
                                       :command="{item, fn: 'contextmenuClick', type: 'preview'}">预览
                      </w-dropdown-item>
                      <w-dropdown-item :disabled="contextMenuDisable.download"
                                       :command="{item, fn: 'downLoadFiles', type: null}">下载
                      </w-dropdown-item>
                      <w-dropdown-item :disabled="contextMenuDisable.delete" :command="{item, fn: 'deleteFiles'}"
                                       v-if="!(!isModuleAdmin && !permission && tabletype === 'companyList')">
                        删除
                      </w-dropdown-item>
                      <w-dropdown-item
                        v-if="!isModuleAdmin&& !permission && tabletype !== 'companyList' && tabletype !== 'projectList'"
                        :disabled="contextMenuDisable.delete" :command="{item, fn: 'copyFilesTap'}">
                        复制到共享空间
                      </w-dropdown-item>
                      <w-dropdown-item :disabled="contextMenuDisable.move" :command="{item, fn: 'moveFilesTap'}"
                                       v-if="!(!isModuleAdmin && !permission && tabletype === 'companyList')">
                        移动到
                      </w-dropdown-item>
                      <w-dropdown-item :disabled="contextMenuDisable.rename"
                                       :command="{item, fn: 'contextMenuFileRename'}"
                                       v-if="!(!isModuleAdmin && !permission && tabletype === 'companyList')">
                        重命名
                      </w-dropdown-item>
                      <w-dropdown-item :disabled="contextMenuDisable.share"
                                       :command="{item, fn: 'contextMenuFileShare'}"
                                       v-if="(tabletype === 'personalList' && !contextMenuDisable.noShare)">
                        分享
                      </w-dropdown-item>
                    </template>
                  </w-dropdown-menu>
                </w-dropdown>
              </div>
              <!--<input :style="{visibility: item.fileType !== 'share' && !isGTJXT(item)? '' : 'hidden'}" type="checkbox"-->
              <!--class="imgItem-checkbox"-->
              <!--:checked="item.checked"-->
              <!--@click.stop="checkboxTap(item, index, $event)"/>-->
              <label
                role="checkbox" aria-checked="true" class="w__checkbox imgItem-checkbox"
                :class="{'is-checked': item.checked}"
                :style="{visibility: item.fileType !== 'share' && !isGTJXT(item)? '' : 'hidden'}"
                @click.stop="checkboxTap(item, index, $event)">
                <span aria-checked="mixed" class="w__checkbox__input" :class="{'is-checked': item.checked}">
                  <span class="w__checkbox__inner"></span>
                  <input type="checkbox" aria-hidden="true" class="w__checkbox__original" value="">
                </span>
              </label>
              <div class="imgItem-box">
                <template
                  v-if="tabletype!=='projectList' && item && item.suffix && (item.suffix + '').toUpperCase() === 'GTJXT'">
                  <i
                    :class="['file-icons', 'icon_' + item.fileProperties.projectType, item.folder ? (item.fileType === 'share' ? 'folder__share' : 'folder') : '']"
                    @mouseenter="personTextBoxStyleHandle(index);"
                    @mouseleave="iconHoverIndex = -1"
                    @click.stop="nameClick(item)"
                  ></i>
                </template>
                <template v-else-if="item.thumbnailUrl">
                  <img
                    :src="item.thumbnailUrl"
                    @mouseenter="personTextBoxStyleHandle(index);"
                    @mouseleave="iconHoverIndex = -1"
                    @click.stop="nameClick(item)"
                  />
                </template>
                <template v-else>
                  <i
                    :class="['file-icons', 'icon_' + item.suffix, 'icon_' + item.fileProperties.projectType, item.folder ? (item.fileType === 'share' ? 'folder__share' : 'folder') : '']"
                    @mouseenter="personTextBoxStyleHandle(index);"
                    @mouseleave="iconHoverIndex = -1"
                    @click.stop="nameClick(item)"
                  ></i>
                </template>
                <div v-if="!item.folder" class="person-textbox" v-show="iconHoverIndex === index">
                  <p>创建时间：{{item.createTime}}</p>
                  <p>文件大小：{{item.size}}</p>
                  <p v-if="tabletype=='projectList'">编制人：{{item.originalCreatorName}}</p>
                  <template v-if="+item.fileType === 1">
                    <p>
                      文件类型：
                      <template v-if="+item.extraInfo === 1">概算</template>
                      <template v-else-if="+item.extraInfo === 2">预算</template>
                      <template v-else-if="+item.extraInfo === 3">结算</template>
                      <template v-else>审核</template>
                    </p>
                  </template>
                  <template v-if="+item.fileType === 2">
                    <p>
                      <label>工程类别：</label>
                      {{item.fileProperties.projectCategory || '【无】'}}
                    </p>
                    <p>
                      <label>结构类型：</label>
                      {{item.fileProperties.structureCategory || '【无】'}}
                    </p>
                    <p>
                      <label>清单规则：</label>
                      {{item.fileProperties.listRule || '【无】'}}
                    </p>
                    <p>
                      <label>定额规则：</label>
                      {{item.fileProperties.quotaRule || '【无】'}}
                    </p>
                  </template>
                </div>
              </div>
              <div class="imgItem-name">
                <a
                  class="imgItem-name-a"
                  v-if="renameData.showIndex !== index"
                  v-on:click.stop="nameClick(item)"
                  v-on:dblclick.stop="fileRename(index,item.name, '', item)"
                  :title="item.name"
                >{{item.name}}</a>
                <div class="w-rename" v-if="renameData.showIndex === index">
                  <w-input size="small" autofocus style="width: 100%;" v-model="renameData.value"
                           @blur="handleRenameBlur(item)" @click.stop="" input-class-name="renameInput"></w-input>
                  <!--<i class="w-icon-tijiao w-rename&#45;&#45;ok" v-on:click.stop="fileRenameSuccess(item)"></i>-->
                  <!--<i class="w-icon-quxiao2 w-rename&#45;&#45;cancel" v-on:click.stop="fileRenameCancel(item)"></i>-->
                </div>
              </div>
              <div class="imgItem-filetime" v-if="renameData.showIndex !== index">{{item.modifyTime}}</div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="mydrag-sel" v-if="mydragSelShow"></div>
    <div class="mydrag-icon" v-show="mydragIconShow"></div>
    <ul class="contextMenu" v-show="contextMenuShow">
      <template v-if="isGTJXT(nowPreview.item)">
        <!-- 我收到的分享工程 文件夹内 右键菜单 -->
        <li @click="contextmenuClick('viewModel')">
          查看模型
        </li>
        <li @click="contextmenuClick('gtjxtmodel')">协同建模</li>
      </template>
      <template v-else-if="showFileListOfShare">
        <!-- 我收到的分享工程 文件夹内 右键菜单 -->
        <li :class="{disable:contextMenuDisable.viewModel}"
            @click="contextmenuClick('viewModel')">
          查看模型
        </li>
        <li :class="{disable: contextMenuDisable.preview}" @click="contextmenuClick('preview')">预览</li>
        <li :class="{disable: contextMenuDisable.download}" @click="contextmenuClick('download')">下载</li>
        <li :class="{disable: contextMenuDisable.unloading}" @click="contextmenuClick('unloading')">转存到我的空间</li>
        <li @click="contextmenuClick('delete')">删除</li>
      </template>
      <template v-else>
        <li :class="{disable:contextMenuDisable.viewModel}"
            @click="contextmenuClick('viewModel')"
        >查看模型
        </li>
        <li :class="{disable:contextMenuDisable.preview}" @click="contextmenuClick('preview')">预览</li>
        <li :class="{disable:contextMenuDisable.download}" @click="downLoadFiles(null)">下载</li>
        <li
          v-if="!(!isModuleAdmin && !permission && tabletype === 'companyList')"
          :class="{disable:contextMenuDisable.delete}"
          @click="deleteFiles()"
        >删除
        </li>
        <li
          v-if="user.role === 4 && !permission && tabletype !== 'companyList' && tabletype !== 'projectList'"
          :class="{disable:contextMenuDisable.delete}"
          @click="copyFilesTap"
        >复制到共享空间
        </li>
        <li
          v-if="!(!isModuleAdmin && !permission && tabletype === 'companyList')"
          :class="{disable:contextMenuDisable.move}"
          @click="moveFilesTap"
        >移动到
        </li>
        <li
          v-if="!(!isModuleAdmin && !permission && tabletype === 'companyList')"
          :class="{disable:contextMenuDisable.rename}"
          @click="contextMenuFileRename"
        >重命名
        </li>
        <li v-if="( tabletype === 'personalList' && !contextMenuDisable.noShare)"
            :class="{disable:contextMenuDisable.share}"
            @click="contextMenuFileShare(true)">
          分享
        </li>
      </template>
    </ul>
    <!-- 下载滚动条 -->
    <!--<DownloadProgress v-if="downloadProgressLaterShow" :value="downloadProgressValue"/>-->
    <!-- 移动到弹层 -->
    <MoveFile v-if="moveLayerShow" :pagetype="tabletype" @affirm="moveAffirm" @cancel="moveCancel"/>

    <!-- 移动到存在多个相同文件替换提示 -->
    <!--<ReplaceFilesHint v-if="replaceFileHintShow" @btnclick="replaceFileHintBtnClick"/>-->
    <!-- 拷贝存在多个相同文件替换提示 -->
    <!--<ReplaceFilesHint v-if="copyReplaceFileHintShow" @btnclick="copyReplaceFileHintBtnClick"/>-->

    <!-- 员工分享工程弹框 -->
    <StaffsDialog v-if="staffsDialogShow" :MemberShow="staffsDialogShow" :porjectInf="porjectInf"
                  @cancel="cancelStaffsDialog"/>
    <!-- 个人分享工程弹框 -->
    <PersonDialog v-if="personDialogShow" :MemberShow="personDialogShow" :porjectInf="porjectInf"
                  @cancel="cancelPersonDialog"/>

    <!-- 分页 -->
    <div class="page-box" v-if="total > 0">
      <w-pagination
        @current-change="handleCurrentChange"
        @size-change="handlePageSizeChange"
        :current-page.sync="pageNum"
        background
        layout="total, prev, pager, next, jumper,sizes"
        :page-size="pageSize"
        :page-sizes="[50, 100]"
        :total="total">
      </w-pagination>
    </div>

    <verify-code @dialogVisibleEvent='showVerify=false' :showVerify="showVerify"
                 @verifyConfirm='verifyConfirm'></verify-code>

  </div>
</template>
<style>
  .w-rename {
    background: transparent;
  }
</style>
<script>
/* eslint-disable no-useless-escape,no-unused-vars */

import {backendUrl} from '@/assets/js/config'
import Bus from '@/assets/utils/bus'
import VerifyCode from '@/components/VerifyCode'
import {sizeConver, formatDay, capitalize, clone, formatDuration} from '@/assets/utils'
import {on, off} from '@zjy/zjy-ui/lib/utils/dom'
import Table from '_c/common/Table/Index.vue'
import {mapState, mapMutations} from 'vuex'
import {getCookie} from '@/assets/utils/CommonUtil'
import {getFileTyeIconClass} from '@/assets/utils/space'
import MoveFile from '_c/common/MoveFile/Index.vue'
// import ReplaceFilesHint from '_c/common/ReplaceFilesHint/Index.vue'
import StaffsDialog from '@/components/common/StaffsDialog.vue'
import PersonDialog from '@/components/common/PersonDialog.vue'
import SpaceService from '@/assets/service/space'
import ManageService from '@/assets/service/manage'
import {
  OperationButtons,
  OperationCrumb,
  // OperationFileType,
  OperationModuleType,
  OperationSearch
} from '@/components/common'
import previewButtonsMixin from '@/assets/mixins/preview-buttons'
import shareFileActionsMixin from '@/assets/mixins/share-file-actions'
import LoginService from '@/assets/service/login'
import _ from 'lodash'

let isOnShift // 是否长按shift
let isOnCtrl // 是否长按ctrl
let clickIndex // 数据点击Index
let trIsMouseEnter // 鼠标是否在数据上
let mouserEnterItemIndex = -1 // 鼠标hover数据index
let isDown // 未checked数据框选判断
let isDownSel // checked数据框选判断
let isAddBox
let starX
let starY
let deleteFileList = []
let downLoadTimer // 删除文件列表
let moveFilesPath = []
let copyFilesPath = []
let nameClickTimer
let floderFiles = []
// let GuideList = clone(require('assets/js/guide').default.list)
// GuideList.forEach((item) => {
//   if (item.createTime) {
//     item.createTime = formatDay(new Date(parseInt(item.createTime)))
//   }
//   if (item.modifyTime) {
//     item.modifyTime = formatDay(new Date(parseInt(item.modifyTime)))
//   }
// })
export default {
  mixins: [previewButtonsMixin, shareFileActionsMixin],
  components: {
    Table,
    OperationButtons,
    OperationCrumb,
    // OperationFileType,
    OperationModuleType,
    OperationSearch,
    MoveFile,
    // ReplaceFilesHint,
    StaffsDialog,
    PersonDialog,
    VerifyCode
  },
  data () {
    return {
      showVerify: false,
      showFileListOfShare: false, // 显示 我收到的分享工程文件列表
      drawFileShow: false,
      // 新手引导使用假数据
      // GuideList: GuideList,
      // 文件替换提示
      // replaceFileHintShow: false,
      // copyReplaceFileHintShow: false,
      // 移动到弹层显示
      moveLayerShow: false,
      // 下载进度弹层显示
      downloadProgressLaterShow: false,
      // 下载进度
      // downloadProgressValue: 0,
      typeFilterData: 'list',
      // 文件筛选类型
      fileType: 0,
      // 右键
      contextMenuShow: false,
      // 右键菜单禁用状态
      contextMenuDisable: {
        viewModel: true,
        preview: true,
        download: false,
        delete: false,
        move: false,
        rename: false,
        share: true, // 右键菜单 分享 置灰
        copy: false,
        unloading: true // 右键菜单 转存 置灰
      },
      // 是否显示框选框
      mydragSelShow: false,
      // 是否显示拖拽图标
      mydragIconShow: false,
      isCheckAll: false,
      // 选择文件数量
      checkedLen: 0,
      // 列表数据
      loading: false,
      dataList: [],
      refreshIndex: 0,
      // 重命名框
      renameData: {
        suffix: '',
        value: '',
        showIndex: -1
      },
      // 排序规则  倒叙 1  顺序 0
      sortType: 1,
      // 排序字段
      sortFieldName: 'modifiedTime',
      // 搜索值
      searchVal: '',
      // 当前路径
      path: '/',
      pageNum: 1,
      pageSize: 50,
      total: 0,
      buttonList: [
        'upload', // 上传
        'addFolder', // 新建文件夹
        'refresh' // 刷新
        // 'download', // 下载
        // 'delete', // 删除
        // 'move', // 移动到
        // 'export', // 导出
        // 'copyToCompanySpace', // 复制到电子档案室
        // 'unfoldTo', // 展开到
        // 'openJurisdiction', // 开通权限
        // 'closeJurisdiction', // 取消权限
        // 'deleteThoroughly', // 彻底删除
        // 'clear', // 清空回收站
        // 'restore', // 还原
        // 'signGroupBest', // 设为最佳组价
        // 'cancelGroupBest' // 取消最佳组价
      ],
      pathItems: [
        {
          // link: 'http://www.glodon.com', // 情况一: 外部链接 优先级最高 可选
          // path: '/vip', //  情况二: 系统内路由跳转 可选
          // params: {}, //  情况二:  系统内路由跳转 参数 可选
          name: '全部文件' // 情况三: 只包含name字段 则触发父组件toFolder(文件夹路径)
        }
      ],
      nowPreview: {
        index: -1,
        item: {}, // 当前正在预览的项
        icon: {} // 当前预览项 配置的预览按钮
      },
      iconHoverIndex: -1, //
      isRaname: false,
      user: {},
      staffsDialogShow: false,
      personDialogShow: false,
      porjectInf: {}
    }
  },
  props: {
    tabletype: {
      type: String
    }
  },
  computed: {
    ...mapState({
      // personalList: state => state.space.personalList,
      workspace: state => state.space.workspace,
      personalFilter: state => state.spacefilter.personalFilter,
      permission: state => state.user.permission,
      enterpriseFilter: state => state.spacefilter.enterpriseFilter,
      projectFilter: state => state.spacefilter.projectFilter,
      guideType: state => state.user.user.guideType,
      isMicro: state => state.menus.isMicro,
      isAsideExpand: state => state.menus.isAsideExpand
    })
  },
  watch: {
    tabletype: function (val) {
      if (val === 'personalList') {
        //  this.dataList = JSON.parse(JSON.stringify(this.personalList));
      }
    },
    //  personalList: function (val) {
    //    if(this.tabletype === "personalList"){
    //      this.dataList = JSON.parse(JSON.stringify(this.personalList));
    //    }
    //  },
    dataList: function () {
      this.setContextmenuStatusAndTopButtons()
    },
    iconListKey: function () {
      if (this.iconListKey) {
        initData(this)
      }
    },
    staffsDialogShow (status) {
      this.setFramesMask(status)
    },
    personDialogShow (status) {
      this.setFramesMask(status)
    }
  },
  methods: {
    calcTableHeight () {
      this.tableHeight = this.getTableHeight('project-table') - this.getTableHeight('content--options') - (this.total > 0 ? 130 : 80)
    },
    _clickHandle (item, trIsMouseEnter) {
      let _self = this
      _self.contextMenuShow = false
      if (trIsMouseEnter > -1) {
        let dataList = JSON.parse(JSON.stringify(_self.dataList))
        // 我收到的分享工程 文件夹 右键菜单 全部置灰
        if (_self.isGTJXT(dataList[trIsMouseEnter])) {
          _self.contextMenuDisable = {
            viewModel: false,
            preview: true
          }
          // _self.judgeGTJXT()
          _self.judgePreview()
          return
        } else if (+trIsMouseEnter === 0 && dataList[trIsMouseEnter] && dataList[trIsMouseEnter].fileType === 'share') {
          _self.contextMenuDisable = {
            viewModel: true,
            preview: true,
            download: true,
            delete: true,
            copyToCompanySpace: true,
            move: true,
            rename: true,
            copy: true,
            noShare: true
          }
          return
        } else {
          _self.contextMenuDisable.noShare = false
          _self.contextMenuDisable.delete = false
          _self.contextMenuDisable.download = false
          _self.contextMenuDisable.copyToCompanySpace = false
          _self.contextMenuDisable.move = false
        }
        let nowIcon = {}
        if (!dataList[trIsMouseEnter].checked) {
          dataList.forEach((item, index) => {
            if (trIsMouseEnter === index) {
              nowIcon = item
              item.checked = true
            } else {
              item.checked = false
            }
          })
          _self.dataList = dataList
        } else {
          nowIcon = dataList[trIsMouseEnter]
        }
        _self.$nextTick(() => {
          _self.judgePreview()
          let checkedCount = 0
          dataList.forEach((item, index) => {
            if (item.checked) {
              checkedCount++
            }
          })
          // 如果是多选时 右键菜单 分享置灰
          _self.$set(_self.contextMenuDisable, 'share', true)
          // console.log(nowIcon.suffix)
          if (checkedCount === 1 && _self.judgeShare(nowIcon.suffix)) {
            /* 当只选择了某一个文件时  判断当前行文件 是否可以分享 */
            _self.$set(_self.contextMenuDisable, 'share', false)
          }
          // 我收到的分享工程 文件内 右键菜单 置灰状态设置
          if (_self.showFileListOfShare) {
            _self.setContextMenuStatus()
          }
        })
      }
    },
    // 列表-更多操作，下拉菜单
    handlerActionByRow ({item, fn}) {
      this[fn](item)
    },
    // 缩略图-更多操作，下拉菜单
    handlerAction ({item, fn, type}) {
      this[fn](type)
    },
    // 重命名失去焦点事件
    handleRenameBlur (item) {
      if (this.renameData.value.trim() !== '') {
        // 员工资料库
        this.fileRenameSuccess(item)
      } else {
        // 员工资料库
        this.fileRenameCancel(item)
      }
    },
    ...mapMutations({
      setPersonalTypeFilter: 'spacefilter/SET_PERSONAL_FILTER',
      setEnterproseTypeFilter: 'spacefilter/SET_ENTERPRISE_FILTER',
      setProjectTypeFilter: 'spacefilter/SET_PROJECT_FILTER'
    }),
    // 获取是不是项目空间中的GTJXT文件
    isGTJXT (item) {
      // if (this.tabletype === 'projectList' && item && item.fileProperties && +item.fileProperties.projectType === 10000 && item.suffix && (item.suffix + '').toUpperCase() === 'GTJXT') {
      if (this.tabletype === 'projectList' && (item.suffix + '').toUpperCase() === 'GTJXT') {
        return true
      } else {
        return false
      }
    },
    // 协同建模
    goGTJXTModel (item, isContextmenu) {
      let wsId = getCookie('projectWorkspaceIdValue')
      let fileId = item.fileId
      let projectid = this.$route.query.prjId
      let prjname = this.$route.query.prjName
      this._sendIOLog('触发协同建模', '协同建模模块', '10011', '-102019', isContextmenu ? '3' : '2', projectid, prjname)
      this._sendIOLog('协同建模', 'web端', '10063', '-102019', isContextmenu ? '3' : '2', projectid, prjname)
      window.open(`/cloudsynergy/fileId/${fileId}`, '_blank')
    },
    // 多功能报表
    goReport (item) {
      let wsId = getCookie('projectWorkspaceIdValue')
      let projectId = this.$route.query.prjId
      let prjname = this.$route.query.prjName
      this._sendIOLog('点击多工程报表', '多工程报表', '10001', '-102020', null, projectId, prjname)
      window.open(`/multicloudreport/wsId/${wsId}/projectId/${projectId}`, '_blank')
    },
    // 分享取消弹框
    cancelStaffsDialog () {
      this.staffsDialogShow = false
    },
    // 分享取消弹框
    cancelPersonDialog () {
      this.personDialogShow = false
    },
    // 更改页码
    handleCurrentChange (index) {
      // 埋点--员工资料库--切换页码
      if (this.tabletype === 'personalList') {
        this.sentLog(100113022)
      }
      this.pageNum = index
      if (this.showFileListOfShare) {
        this.getShareFileList()
      } else {
        initData(this, true)
      }
    },
    // 更改页面大小
    handlePageSizeChange (index) {
      // 埋点--员工资料库--下一页
      if (this.tabletype === 'personalList') {
        this.sentLog(+index === 50 ? 100113023 : 100113024)
      }
      this.pageSize = index
      this.pageNum = 1
      if (this.showFileListOfShare) {
        this.getShareFileList()
      } else {
        initData(this, true)
      }
    },
    // 将 val 全部转换成小写
    capitalize (val) {
      return capitalize(val, true, true)
    },
    // 全选
    checkAll () {
      // this.isCheckAll = !this.isCheckAll
      let dataList = [...this.dataList]
      dataList = dataList.map(item => {
        if (item.fileType !== 'share' && !this.isGTJXT(item)) {
          item.checked = this.isCheckAll
        }
        return {
          ...item
        }
      })
      this.dataList = dataList
    },
    checkboxTap (item, index, e) {
      //  e = window.event || e;
      e.preventDefault()
      e.stopPropagation()
      this.$set(this.dataList[index], 'checked', !item.checked)
      let isCheckAll = true
      this.dataList.forEach(tr => {
        if (!tr.checked && !this.isGTJXT(tr)) {
          isCheckAll = false
        }
      })
      this.isCheckAll = isCheckAll
      this.refreshIndex++
      // 设置 右键菜单 和 顶部操作按钮组
      this.setContextmenuStatusAndTopButtons()
    },
    trMouseEnter (item, index) {
      trIsMouseEnter = index
      if (item.checked) {
        mouserEnterItemIndex = index
      }
    },
    trMouseLeave (item) {
      trIsMouseEnter = -1
      mouserEnterItemIndex = -1
    },
    // 单行选中
    trClick (index, item) {
      if ((item && item.fileType === 'share') || this.isGTJXT(item)) {
        return
      }
      let dataobj = {...this.dataList[index]}
      this.contextMenuShow = false
      dataobj.checked = !dataobj.checked
      if (!dataobj.checked) {
        console.log(1)
        isDown = false
      }
      if (isOnShift) {
        if (clickIndex === undefined) {
          return
        }
        let dataList = [...this.dataList]
        dataList = dataList.map((item, itemindex) => {
          if (clickIndex >= index) {
            if (itemindex >= index && itemindex <= clickIndex) {
              item.checked = true
            } else {
              item.checked = false
            }
          } else if (clickIndex < index) {
            if (itemindex <= index && itemindex >= clickIndex) {
              item.checked = true
            } else {
              item.checked = false
            }
          }
          return {
            ...item
          }
        })
        this.dataList = dataList
      } else {
        clickIndex = index
        this.dataList.splice(index, 1, dataobj)
      }
      let isCheckAll = true
      this.dataList.forEach(tr => {
        if (!tr.checked && !this.isGTJXT(tr)) {
          isCheckAll = false
        }
      })
      this.isCheckAll = isCheckAll
    },
    // 排序
    sortClick (name) {
      // 埋点
      if (name === 'name_chn') {
        this.sentLog(100114018, {page: 1, type: this.sortFieldName === name ? +this.sortType === 1 ? 2 : 1 : 1})
      } else if (name === 'modifiedTime') {
        this.sentLog(100114017, {page: 1, type: this.sortFieldName === name ? +this.sortType === 1 ? 2 : 1 : 1})
      } else {
        this.sentLog(100114016, {page: 1, type: this.sortFieldName === name ? +this.sortType === 1 ? 2 : 1 : 1})
      }

      if (this.sortFieldName === name) {
        this.sortType = +this.sortType === 1 ? 0 : 1
      } else {
        this.sortFieldName = name
        this.sortType = 1
      }
      initData(this)
    },
    // 判断是否已经二次验证
    // async isDoubleVerify () {
    //   const userinfo = JSON.parse(getCookie('ZJYUSERINFO'))
    //   this.phone = userinfo.passwordMobile
    //   let result = await new Promise((resolve, reject) => {
    //     LoginService.isDoubleVerify(userinfo.passwordMobile).then(res => {
    //       if (res.code === 200) {
    //         if (res.data) { // 需要二次验证-弹出弹框
    //           console.log('未二次验证！')
    //           this.showVerify = true
    //           resolve(true)
    //         } else { // 已经验证过
    //           console.log('二次验证已通过！')
    //           resolve(false)
    //         }
    //       } else {
    //         this.$message.error(res.msg)
    //       }
    //     })
    //   })
    //   return result
    // },

    // 二次验证---确定
    verifyConfirm () {
      console.log('验证成功，请继续操作！')
    },
    // 删除文件（单个删除、批量删除）
    async deleteFiles (item, isTopButton = false) {
      //  this.$showDoubleVerify(true)
      let checkedCount = 0
      this.dataList.forEach((item, index) => {
        if (item.checked) {
          checkedCount++
        }
      })
      // 埋点--共享空间
      if (this.tabletype === 'companyList') {
        // 埋点--右键
        if (item) {
          this.sentLog(100114005, {count: 1})
        } else if (isTopButton) {
          this.sentLog(100114021, {count: checkedCount})
        } else {
          this.sentLog(100114009, {count: checkedCount})
        }
      } else {
        // 埋点--员工资料库
        if (item) {
          this.sentLog(100113018, {count: 1})
        } else {

          if (isTopButton) {
            this.sentLog(100113017, {count: checkedCount})
          } else {
            this.sentLog(100113019, {count: checkedCount})
          }
        }
      }
      // if (this.tabletype !== 'personalList') {
      //   let flag = await this.isDoubleVerify()
      //   if (flag) {
      //     return false
      //   }
      // }
      // 埋点--结束
      if (!item) {
        // 批量删除
        if (this.contextMenuDisable.delete) return
        this.contextMenuShow = false
        this.findSelectItems()
      } else {
        // 单个删除
        deleteFileList = [item]
      }
      if (this.showFileListOfShare) {
        // 我收到的分享工程 文件夹内 删除
        this.deleteShareFileConfirm(deleteFileList)
      } else {
        // 其他文件删除
        this.$confirm({
          message: '确定要把文件删除？',
          type: 'primary',
          tips: '删除文件可以通过“回收站”来还原',
          submit: () => {
            delFiles(this)
          },
          submitText: '确定删除',
          cancelText: '取消'
        })
      }
    },
    // 寻找已选择的 行
    findSelectItems () {
      let nowItem = null
      let count = 0
      let dataList = [...this.dataList]
      deleteFileList = []
      dataList.map(item => {
        if (item.checked) {
          count++
          nowItem = item
          deleteFileList.push(item)
        }
      })
      if (count > 1) {
        nowItem = null
      }
      return nowItem
    },
    // 没有共享空间权限提示
    confirmPermission (message = '') {
      if (message) {
        this.$confirm({
          message,
          type: 'noPermission',
          width: 420,
          noCancelBtn: true,
          submitText: '确定'
        })
      } else {
        this.$confirm({
          // message: `您没有共享空间权限，请联系负责人${adminName.join('或')}获取权限。`,
          message: '您没有共享空间权限，请联系负责人获取权限。',
          type: 'noPermission',
          width: 420,
          noCancelBtn: true,
          submitText: '确定'
        })
        // ManageService.getRole({token: getCookie('ZJYTOKEN'), users: [2]}).then(res => {
        //   let data = res.data || []
        //   let adminName = []
        //   data.forEach(item => {
        //     adminName.push((item.username || '') + (item.name ? '(' + (item.name || '') + ')' : ''))
        //   })
        //   // 员工 无权下载 企业空间文件
        //   this.$confirm({
        //     // message: `您没有共享空间权限，请联系负责人${adminName.join('或')}获取权限。`,
        //     message: '您没有共享空间权限，请联系负责人获取权限。',
        //     type: 'noPermission',
        //     width: 420,
        //     noCancelBtn: true,
        //     submitText: '确定'
        //   })
        // }).catch(() => {
        //   this.$message.error('获取负责人信息失败')
        // })
      }
    },
    // 下载单文件
    async downloadFile (item) {
      const {suffix, fileId, folder, permission, length} = item
      // 是否有 预览权限 校验
      if (folder) {
        this.downLoadFiles([item])
        return
      }
      let fnCode = this.tabletype === 'companyList' ? 100114007 : 100113015
      if (!permission) {
        if (this.tabletype === 'companyList') {
          this.confirmPermission()
        }
        // 埋点：下载失败
        this.sentLog(fnCode, {files: [{suffix, fileId, length, status: 0}], code: 403})
        return
      }
      // if (this.tabletype !== 'personalList') {
      //   let flag = await this.isDoubleVerify()
      //   if (flag) {
      //     // 埋点：下载失败
      //     this.sentLog(fnCode, {files: [{suffix, fileId, length, status: 0}], code: 402})
      //     return false
      //   }
      // }
      let path = item.path
      path = encodeURIComponent(path)
      let token = getCookie('ZJYTOKEN')
      let workspaceId = getWorkspaceId(this)
      this.addOperationRecords(1, item)
      SpaceService.downloadFile_new(path, token, workspaceId).then((res) => {
        const {data, code, message} = res.data
        if (code === 200){
          window.common.downloadFile(data)
          // 埋点：下载成功
          this.sentLog(fnCode, {files: [{suffix, fileId, length, status: 1}]})
        } else {
          this.$message.error(message)
          // 埋点：下载失败
          this.sentLog(fnCode, {files: [{suffix, fileId, length, status: 0}]})
        }
      }).catch(() => {
        // 埋点：下载失败
        this.sentLog(fnCode, {files: [{suffix, fileId, length, status: 0}]})
      })
    },
    // 下载多文件
    async downLoadFiles (downItems, isTopButton = false) {
      let list = downItems || this.dataList.filter(item => item.checked)
      if (list.length === 0) {
        return
      }
      let logData = {
        extJson: {
          files: list.map(item => {
            return {
              length: item.length,
              fileId: item.fileId,
              suffix: item.suffix,
              status: 0
            }
          }),
          count: list.length
        }
      }
      // 共享空间
      if (this.tabletype === 'companyList' && !downItems) {
        if (isTopButton) {
          logData.fnCode = 100114020
          // this.sentLog(100114020, {count: list.length})
        } else {
          logData.fnCode = 100114010
          // this.sentLog(100114010, {count: list.length})
        }
      } else {
        // 员工资料库
        if (isTopButton) {
          logData.fnCode = 100113014
          // this.sentLog(100113014)
        } else {
          logData.fnCode = 100113016
          // this.sentLog(100113016)
        }
      }
      this.contextMenuShow = false
      // 共享空间是否有下载权限
      if (this.tabletype === 'companyList' && !(this.isModuleAdmin || (!this.isModuleAdmin && this.permission))) {
        let beDownLoad = true
        list.forEach(item => {
          if (!item.permission) { // !item.permission && !item.folder
            beDownLoad = false
          }
        })
        if (!beDownLoad) {
          this.sentLog(logData.fnCode, Object.assign(logData.extJson, {code: 403}))
          this.confirmPermission()
          // // 没有权限提示
          // this.$confirm({
          //   message:
          //     list.length === 1 ? '您没有共享空间权限，请联系负责人xxx（总负责人姓名，有则显示）、xxx（档案室负责人姓名，有则显示）获取权限。'
          //       : '部分工程需要企业空间权限，请联系管理员获取权限。',
          //   // message: list.length === 1 ? '您没有企业空间权限，请联系管理员获取权限。' : '部分工程需要企业空间权限，请联系管理员获取权限。',
          //   // tips: '管理员账号为：' + this.user.adminAccount,
          //   type: 'noPermission',
          //   width: 420,
          //   noCancelBtn: true,
          //   cancel: () => {
          //     this.$store.commit('user/SET_TO_LOGIN_AS_ADMIN')
          //   },
          //   submitText: '确定',
          //   cancelText: '我是管理员'
          // })
          return
        }
      }
      // if (this.tabletype !== 'personalList') {
      //   let flag = await this.isDoubleVerify()
      //   if (flag) {
      //     return false
      //   }
      // }
      let filePathListm = []
      let folderPathList = []
      let workspaceId = getWorkspaceId(this)
      list.map(item => {
        if (item.folder) {
          folderPathList.push(item.path)
        } else {
          filePathListm.push(item.path)
        }
      })
      let parameter = {
        filePathListm,
        folderPathList,
        workspaceId
      }
      SpaceService.downloadFiles(parameter).then(res => {
        if (+res.code === 200) {
          // 埋点--员工资料库-下载成功
          // 记录操作-下载
          this.addOperationRecords(1, list)
          if (res.data) {
            if (res.data.dataUrl) {
              this.downloadProgressLaterShow = true
              getDownloadFilesState(this, res.data.dataUrl, {logData})
            } else {
              this.sentLog(logData.fnCode, Object.assign(logData.extJson, {code: res.code}))
              this.$message.warning('文件夹是空')
            }
          }
        } else if (+res.code === 403) {
          this.sentLog(logData.fnCode, Object.assign(logData.extJson, {code: res.code}))
          if (this.tabletype === 'companyList') {
            this.confirmPermission()
            // // 员工 无权下载 企业空间文件
            // this.$confirm({
            //   message: '您没有共享空间权限，请联系负责人xxx（总负责人姓名，有则显示）、xxx（档案室负责人姓名，有则显示）获取权限。',
            //   // message: '您没有企业空间权限，请联系管理员获取权限。',
            //   // tips: '管理员账号为：' + this.user.adminAccount,
            //   type: 'noPermission',
            //   width: 420,
            //   noCancelBtn: true,
            //   cancel: () => {
            //     this.$store.commit('user/SET_TO_LOGIN_AS_ADMIN')
            //   },
            //   submitText: '确定',
            //   cancelText: '我是管理员'
            // })
          }
        } else {
          this.sentLog(logData.fnCode, Object.assign(logData.extJson, {code: res.code}))
          this.$message.error(res.message ? res.message : '下载失败！')
        }
      })
    },
    // 右键菜单 重命名 点击
    contextMenuFileRename () {
      // 共享空间
      if (this.tabletype === 'companyList') {
        let keyMap = {
          list: 'space.contextMenuRenameByList',
          thumbnail: 'space.contextMenuRenameByThumbnail'
        }
      }
      if (this.contextMenuDisable.rename) {
        return
      }
      this.dataList.map((item, index) => {
        if (item.checked) {
          this.fileRename(index, item.name, 'contextmenu', item)
        }
      })
    },
    // 右键菜单 分享 点击
    contextMenuFileShare (clickContextmenu) {
      if (this.contextMenuDisable.share) return
      this.dataList.map((item) => {
        if (item.checked) {
          this.shareFile(item, clickContextmenu)
        }
      })
    },
    // 分享 操作
    shareFile (item, clickContextmenu) {
      let logCode = 0
      if (!clickContextmenu) {
        // 点击右侧分享按钮、缩略图模式 下拉操作 分享
        logCode = +this.user.role < 5 ? 100113058 : 100113063
      } else {
        // 点击右键菜单 分享
        logCode = +this.user.role < 5 ? 100113059 : 100113064
      }
      logCode && this.sentLog(logCode)


      const tenantInfo = JSON.parse(sessionStorage.getItem('TenantInfo'))
      // 员工、个人 分享.....
      if (tenantInfo.categoryCodes !== 'personal') {
        this.staffsDialogShow = true
        // this.sentLog(100113005, {type: item.suffix})
      } else {
        this.personDialogShow = true
      }
      this.porjectInf = item
    },
    // 重命名
    fileRename (index, name, actionType, item) {
      // 共享空间
      if (this.tabletype === 'companyList') {
        let keyMap = {
          list: 'space.menuRenameByList',
          thumbnail: 'space.menuRenameByThumbnail'
        }
      } else {
        //
      }
      // 双击GTJXT文件无反应
      if (item && this.isGTJXT(item)) {
        this.gtjxt = true
        this.nameClick(item)
        return
      }
      // 双击 我收到的分享工程文件夹时 不重命名
      if (item && item.fileType === 'share') {
        this.nameClick(item)
        return
      }
      let value = name
      let suffix = ''
      if (!item.folder) {
        value = name.substring(0, name.lastIndexOf('.'))
        suffix = name.substring(name.lastIndexOf('.') + 1)
      }
      if (this.tabletype === 'companyList' && !this.isModuleAdmin && !this.permission) {
        return
      }
      clearTimeout(nameClickTimer)
      this.renameData = {
        suffix,
        value,
        showIndex: index
      }
      this.contextMenuShow = false
      if (this.isRaname) {
        setTimeout(() => {
          let queryinput = document.querySelector('.renameInput')
          if (queryinput) {
            queryinput.setSelectionRange(0, name.length)
            queryinput.focus()
          }
        }, 200)
        return
      } else {
        this.isRaname = true
      }
      setTimeout(() => {
        let queryinput = document.querySelector('.renameInput')
        if (queryinput) {
          queryinput.setSelectionRange(0, name.length)
          queryinput.focus()
        }
      }, 200)
    },
    // 重命名确定
    fileRenameSuccess (item) {
      let name = this.renameData.value.replace(/^\s*|\s*$/g, '')
      let reg = /^(?!\.)(?!com[0-9]\$)(?!con\$)(?!lpt[0-9]\$)(?!nul$)(?!prn\$)[^\|\*\"\?\\:<>\$]*[^\/\.\|\*\?\"\\:<>\$]+$/
      if (name === '') {
        this.$message.warning('文件名不能为空')
        return
      }
      if (!reg.test(name)) {
        this.$message.warning(
          '文件名不能包含下列任何字符：\\ / : * ? " < > $ |  并且不能以 . 开头和结尾'
        )
        return
      }
      if (name.length > 83) {
        this.$message.warning('文件名字长度应该不超过83个字符长度 ')
        return
      }
      if (!item.isCreateFolder) {
        // 修改名称
        // console.log(item);
        let parameter = {
          newName:
            name +
            (this.renameData.suffix
              ? '.' + this.renameData.suffix
              : this.renameData.suffix),
          path: item.path,
          workspaceId: getWorkspaceId(this)
        }
        if (parameter.newName === item.name) {
          this.fileRenameCancel()
          return
        }
        // 防止多次点击
        if (this.renameOk) {
          return
        } else {
          this.renameOk = true
        }
        SpaceService.putFileRename(parameter).then(res => {
          // console.log("putFileRename====>", res);
          this.isRaname = false
          this.renameOk = false
          if (+res.code === 200) {
            // 操作记录-重命名
            item.path = item.path + '->' + parameter.newName
            // this.recordsDataOpration(6, item);
            this.addOperationRecords(6, item)
            initData(this)

          } else if (+res.code === 270014) {
            if (res.data[0].filePath === res.data[0].lockUsers[0].filePath) {
              this.$confirm({
                message: "当前文件或文件夹正在被<em style='color: #1c6ccd;'>" +
                  (res.data[0].lockUsers[0].lockUserName
                    ? res.data[0].lockUsers[0].lockUserName
                    : '其他') +
                  '</em>账号操作，为避免编辑的内容被相互覆盖或文件丢失，暂不可进行此操作，请稍后重试。',
                noCancelBtn: true,
                width: 470
              })
            } else if (res.data[0].filePath.indexOf(res.data[0].lockUsers[0].filePath) !== -1) {
              const projectname = res.data[0].lockUsers[0].filePath.split('/').reverse()[0]
              this.$confirm({
                message: "当前文件或文件夹的父文件夹<em style='color: #1c6ccd;'>（" +
                  projectname +
                  "）</em>正在被<em style='color: #1c6ccd;'>" +
                  (res.data[0].lockUsers[0].lockUserName
                    ? res.data[0].lockUsers[0].lockUserName
                    : '其他') +
                  '</em>账号操作，为避免编辑的内容被相互覆盖，暂不可进行此操作，请稍后重试。',
                noCancelBtn: true,
                width: 470
              })
            } else if (res.data[0].lockUsers[0].filePath.indexOf(res.data[0].filePath) !== -1) {
              const projectname = res.data[0].lockUsers[0].filePath.split('/').reverse()[0]
              this.$confirm({
                message: "当前文件夹下的文件或者文件夹<em style='color: #1c6ccd;'>（" +
                  projectname +
                  "）</em>正在被<em style='color: #1c6ccd;'>" +
                  (res.data[0].lockUsers[0].lockUserName
                    ? res.data[0].lockUsers[0].lockUserName
                    : '其他') +
                  '</em>账号操作，为避免文件丢失，暂不可进行此操作，请稍后重试。',
                noCancelBtn: true,
                width: 470
              })
            }
          } else {
            this.$message.error(res && res.message ? res.message : '修改失败！')
          }
        }).catch()
      } else {
        // 员工资料库
        if (this.tabletype !== 'companyList') {
          this.sentLog(100113007, {message: this.renameData.value})
        }
        // 防止多次点击
        if (this.renameOk) {
          return
        } else {
          this.renameOk = true
        }
        // 创建文件验证
        let path = this.path === '/' ? '' : this.path
        let parameter = {
          path: path + '/' + this.renameData.value,
          workspaceId: getWorkspaceId(this)
        }
        // 员工、个人在自己空间根目录 新建一个名为“我收到的分享工程”文件夹时 提示文件夹已存在
        if (this.dataList && this.dataList[0] &&
          this.dataList[0].fileType === 'share' && /^\s*我收到的分享工程\s*$/.test(this.renameData.value)) {
          this.$message.warning('文件夹已存在')
          this.renameOk = false
          return
        }
        SpaceService.createFolder(parameter).then(res => {
          if (+res.code === 200) {
            this.isRaname = false
            this.renameOk = false
            initData(this)
          } else {
            this.$message.error(res.message)
            this.renameOk = false
          }
        }).catch(() => {
          this.$message.error('创建文件夹失败！')
          this.isRaname = false
          this.renameOk = false
        })
        // let path = this.path === "/" ? "" : this.path;
        // let parameter = {
        //   fileNameList: [this.renameData.value],
        //   parentPath: path + "/",
        //   workspaceId: getWorkspaceId(this)
        // };
        // SpaceService.fileExist(parameter).then(res => {
        //   if (+res.code === 200) {
        //     if (res.data && res.data.length > 0) {
        //       this.$message.warning(this.renameData.value + "已经存在,请使用其它名称");
        //     } else {
        //       //创建文件夹
        //       let path = this.path === "/" ? "" : this.path;
        //       let parameter = {
        //         path: path + "/" + this.renameData.value,
        //         workspaceId: getWorkspaceId(this)
        //       };
        //       SpaceService.createFolder(parameter).then(res => {
        //         if (+res.code === 200) {
        //           // this.fileRenameCancel();
        //           initData(this);
        //         } else {
        //           this.$message.error(res.message);
        //         }
        //       });
        //     }
        //   } else {
        //     this.$message.error(res && res.message ? res.message : "校验文件失败！");
        //   }
        // });
      }
    },
    // 重命名取消
    fileRenameCancel (item) {
      const showIndex = this.renameData.showIndex
      this.isRaname = false
      this.renameData = {
        suffix: '',
        value: '',
        showIndex: -1
      }
      this.renameOk = false
      if (item) {
        if (item.isCreateFolder) {
          let datalist = JSON.parse(JSON.stringify(this.dataList))
          if (showIndex === 1) {
            datalist.splice(1, 1)
          } else {
            // datalist = datalist.splice(1);
            datalist.shift()
          }
          this.dataList = datalist
        }
      }
    },
    // 列表预览
    previewHandle (item, icon, viewAction) {
      const {suffix, fileId, length} = item
      // 共享空间
      if (this.tabletype === 'personalList') {
        this.sentLog(100113071, {files: [{suffix, fileId, length, status: 1}], length, status: 1})
      } else if (this.tabletype === 'companyList') {
        this.sentLog(100114006, {files: [{suffix, fileId, length, status: 1}], length, status: 1})
      } else {
        this.sentLog(100112041, {files: [{suffix, fileId, length, status: 1}], length, status: 1})
      }

      this.preview(item, icon, viewAction)
    },
    // gjtxt 模型浏览
    previewgtjxt (item) {
      // gjtxt 模型浏览埋点
      let projectid = this.$route.query.prjId
      let prjname = this.$route.query.prjName
      this._sendIOLog('查看模型', 'web端', '10062', '-102019', '2', projectid, prjname)
      // gjtxt 模型浏览
      this.preview(item, this.previewIcon[this.capitalize('gtj')], 2)
    },
    // 名称点击
    nameClick (item) {
      this.contextMenuShow = false
      if (this.loading) return
      console.log(item)
      // 进入文件夹
      clearTimeout(nameClickTimer)
      // gtjxt 双击不触发点击
      if (this.gtjxt) {
        this.gtjxt = false
        return
      }
      nameClickTimer = setTimeout(() => {
        if (item.folder) {
          this.path = item.path
          this.dataList = []
          this.pathItems.push({
            name: item.name
          })
          if (item.fileType === 'share') {
            // 进入我收到的分享工程 文件夹
            this.searchVal = ''
            trIsMouseEnter = -1 // 防止 我收到的分享工程文件夹内 表格区域以外的地方出现 区域选择框
            this.getShareFileList(1)
          } else {
            initData(this)
          }
        } else {
          // 如果是GTJXT
          if (this.isGTJXT(item)) {
            this.preview(item, this.previewIcon[this.capitalize('gtj')], 1)
            let projectid = this.$route.query.prjId
            let prjname = this.$route.query.prjName
            this._sendIOLog('查看模型', 'web端', '10062', '-102019', '2', projectid, prjname)
            return
          }
          if (
            this.iconListKey &&
            this.previewIcon[this.capitalize(item.suffix)] &&
            this.previewIcon[this.capitalize(item.suffix)].suffix
          ) {
            // 我收到的分享工程列表 内 文件名称 或 icon点击 执行预览
            if (this.showFileListOfShare) {
              this.shareFileActionEmitter('preview', item)
            } else {
              this.preview(item, this.previewIcon[this.capitalize(item.suffix)], 1)
            }
          }
        }
      }, 800)
    },
    // 顶部按钮点击
    topButtonClick (type, e) {
      if (type === 'addFolder') {
        createdFolder(this)
      } else if (type === 'refresh') {
        if (this.tabletype === 'personalList') {
          this.sentLog(100113008)
        }
        if (this.showFileListOfShare) {
          this.getShareFileList()
        } else {
          initData(this)
        }
      } else if (type === 'delete') {
        this.deleteFiles(null, true)
      } else if (type === 'download') {
        this.downLoadFiles(null, true)
      } else if (type === 'move') {
        this.moveFilesTap(null, true)
      } else if (type === 'copyToCompanySpace') {
        this.copyFilesTap(null, true)
      } else if (type === 'cancel') {
        this.isCheckAll = false
        this.checkAll()
      }
    },
    getPathNameG () {
      let name = '全部文件'
      if (+this.fileType === 1) {
        name = '计价文件'
      }
      if (+this.fileType === 2) {
        name = '计量文件'
      }
      return name
    },
    // 面包屑点击
    queryPathList (data) {
      this.$refs.operationSearch.clearSearchValue()
      this.searchVal = ''
      if (data.filepath === `/${this.getPathNameG()}`) {
        this.path = '/'
        this.pathItems = [{name: `${this.getPathNameG()}`}]
      } else {
        this.path = data.filepath
        this.pathItems = data.items
      }
      if (data.filepath === '/我收到的分享工程' && this.showFileListOfShare) {
        // 当前展示的就是 我收到的分享工程 列表 时 面包屑 我收到的分享工程 点击
        this.getShareFileList(1)
      } else {
        if (this.showFileListOfShare) {
          // let otherHeight = 45 + 55 + 52 + 100 + 40
          // this.setTableHeight(otherHeight)
          this.showFileListOfShare = false // 隐藏 我收到的分享工程文件夹
        }
        initData(this)
      }
    },
    // 获取列表是图片模式还是列表模式
    getTypeFilterData () {
      if (this.tabletype === 'personalList') {
        this.typeFilterData = this.personalFilter.listType
      }
      if (this.tabletype === 'companyList') {
        this.typeFilterData = this.enterpriseFilter.listType
      }
      if (this.tabletype === 'projectList') {
        this.typeFilterData = this.projectFilter.listType
      }
    },
    // 列表类型切换
    typeQueryList (data) {
      console.log(data)
      this.path = '/'
      // 个人空间
      if (this.tabletype === 'personalList') {
        let typeFilterData = {...this.personalFilter}
        typeFilterData.fileType = data.fileType
        this.fileType = data.fileType
        this.setPersonalTypeFilter(typeFilterData)
        // 存入localstorage 类型
        localStorage.setItem('personalFileType', data.fileType)
        initData(this)
      }
      // 企业空间
      if (this.tabletype === 'companyList') {
        let typeFilterData = {...this.enterpriseFilter}
        typeFilterData.fileType = data.fileType
        this.fileType = data.fileType
        this.setEnterproseTypeFilter(typeFilterData)
        // 存入localstorage 类型
        localStorage.setItem('companyFileType', data.fileType)
        initData(this)
      }
      // 项目库
      if (this.tabletype === 'projectList') {
        this.path = '/' + this.$route.query.prjName
        this.pathItems = [{name: this.$route.query.prjName}]
        let typeFilterData = {...this.projectFilter}
        typeFilterData.fileType = data.fileType
        this.fileType = data.fileType
        this.setProjectTypeFilter(typeFilterData)
        // 存入localstorage 类型
        localStorage.setItem('projectFileType', data.fileType)
        initData(this)
      }
      this.pathItems = [{name: `${this.getPathNameG()}`}]
    },
    // 列表图片切换
    moduleTypeQueryList (data) {
      // 个人空间
      if (this.tabletype === 'personalList') {
        // 埋点--员工资料库--缩略图
        this.sentLog(100113021, {type: data.moduleType === 'list' ? 1 : 2})
        // 埋点--结束
        let typeFilterData = {...this.personalFilter}
        if (data.moduleType) {
          typeFilterData.listType = data.moduleType
          this.typeFilterData = data.moduleType
        }
        this.setPersonalTypeFilter(typeFilterData)
      }
      // 企业空间
      if (this.tabletype === 'companyList') {
        let typeFilterData = {...this.enterpriseFilter}
        if (data.moduleType) {
          typeFilterData.listType = data.moduleType
          this.typeFilterData = data.moduleType
        }
        this.setEnterproseTypeFilter(typeFilterData)
      }
      // 项目库
      if (this.tabletype === 'projectList') {
        let typeFilterData = {...this.projectFilter}
        if (data.moduleType) {
          typeFilterData.listType = data.moduleType
          this.typeFilterData = data.moduleType
        }
        this.setProjectTypeFilter(typeFilterData)
      }
      this.sortFieldName = data.sortFieldName
      this.sortType = data.sortType
      initData(this)
      // setTimeout(() => {
      //   handelTextBoxStyle(this);
      // }, 300);
    },
    // 复制到共享空间
    copyFilesTap (event = null, isTopButton = false) {
      copyFilesPath = this.dataList.filter(item => item.checked)
      // 埋点--员工资料库
      if (this.tabletype === 'personalList') {
        this.sentLog(isTopButton ? 100113009 : 100113010, {count: copyFilesPath.length})
      }
      this.contextMenuShow = false
      this.$confirm({
        message: '确定要把文件复制到共享空间吗？',
        type: 'primary',
        tips: '为了避免长时间等待，请每次操作少量文件.',
        submit: () => {
          this.fileCopyExist()
        }
      })
    },
    // 拷贝验证
    fileCopyExist () {
      // let fileNameList = copyFilesPath.map(item => item.name);
      // let parameter = {
      //   fileNameList,
      //   parentPath: "/",
      //   workspaceId: getWorkspaceIdByType("company")
      // };
      const filePathList = []
      const folderPathList = []
      copyFilesPath.forEach((item) => {
        let path = item.path
        // path = path.replace(/^\/+/, '')
        if (item.folder) {
          folderPathList.push(path)
        } else {
          filePathList.push(path)
        }
      })
      const parameter = {
        filePathList,
        folderPathList,
        // sourceParentPath: '/',
        targetPath: '/',
        sourceWorkspaceId: getWorkspaceId(this),
        targetWorkspaceId: getWorkspaceId(this, true)
      }
      SpaceService.fileExist(parameter).then(res => {
        // console.log(res);
        if (+res.code === 200 && res.data) {
          console.log(res)
          if (res.data.sameNameFiles && res.data.sameNameFiles.length > 0) {
            // this.copyReplaceFileHintShow = true
            this.$confirm({
              message: '存在一个或多个文件重名，是否替换？',
              width: 400,
              multipleSubmit: [
                {name: '替换', key: 'data', value: 1},
                {name: '追加', type: 'minor', key: 'data', value: 2},
                {name: '跳过', type: 'minor', key: 'data', value: 3}
              ],
              noCancelBtn: true,
              submit: ({data}) => {
                this.fileCopy(data)
                // console.log(data)
              },
              cancel: () => {
              }
            })
          } else {
            this.fileCopy()
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 文件替换提示click
    // copyReplaceFileHintBtnClick(val) {
    //   if (val === 'close') {
    //     this.copyReplaceFileHintShow = false
    //     return
    //   }
    //   this.fileCopy(val)
    //   this.copyReplaceFileHintShow = false
    // },
    // 校验容量
    checkCapacity (fileSize) {
      return new Promise((resolve, reject) => {
        let workspaceId = getCookie('enterpriseWorkspaceIdValue')
        fileSize = fileSize || 0
        SpaceService.getWorkspaceById({workspaceId}).then(data => {
          if (+data.code === 200) {
            let {totalCapacity, usedCapacity} = data.data
            usedCapacity = usedCapacity || 0
            totalCapacity = totalCapacity || 0
            if (
              parseInt(totalCapacity) >
              parseInt(usedCapacity) + parseInt(fileSize)
            ) {
              resolve()
            } else {
              this.$message.info('企业共享空间容量不足，请您联系管理员进行扩容')
              reject(new Error('error log'))
            }
          }
        })
      })
    },
    // 拷贝
    fileCopy (operationType) {
      const ZJYTOKEN = getCookie('ZJYTOKEN')
      let sourceFileList = []
      let sourceFolderList = []
      let filesize = 0
      copyFilesPath.map(item => {
        if (item.folder) {
          sourceFolderList.push(item.path)
        } else {
          if (item.length) {
            filesize = filesize + parseInt(item.length)
          }
          sourceFileList.push(item.path)
        }
      })
      this.checkCapacity(filesize).then(() => {
        const cacheKey = new Date().getTime() + '_' + ZJYTOKEN
        let parameter = {
          cacheKey,
          operationType: operationType || 1,
          paramType: 'filePath',
          sourceWorkspaceId: getWorkspaceId(this),
          targetFile: '/',
          targetWorkspaceId: getWorkspaceIdByType('company'),
          sourceFileList: sourceFileList,
          sourceFolderList: sourceFolderList
        }
        let taskComplete = 0
        let result = null
        const afterTask = () => {
          // 进度到100%、并且有有返回数据时执行
          if (taskComplete && result) {
            if (+result.code === 200 || (taskComplete > 1 && +result.code === -1)) {
              this.$message.success('已成功复制到共享空间')
              initData(this)
            } else {
              this.$message.error('复制到共享空间失败')
            }
            this.topButtonClick('refresh')
          }
        }
        SpaceService.fileCopy(parameter).then(res => {
          result = res
          afterTask()
        })
        this.getProgress('copy', '', 'COPY_FLAG_' + cacheKey, true).then(({hit}) => {
          taskComplete = hit
          afterTask()
        })
      })
    },
    // 多文件移动到点击
    moveFilesTap (event = null, isTopButton = false) {
      if (this.contextMenuDisable.move) {
        return
      }
      this.contextMenuShow = false
      moveFilesPath = this.dataList.filter(item => item.checked)
      this.moveLayerShow = true
      // 员工资料库
      if (this.tabletype === 'personalList') {
        this.sentLog(isTopButton ? 100113011 : 100113012, {count: moveFilesPath.length})
      }
    },
    // 移动到确定
    moveAffirm (val) {
      this.moveLayerShow = false
      if (val === this.path) {
        this.$message.error('移动失败')
        return
      }

      this.fileMoveExist(val)
    },
    // 移动到验证
    fileMoveExist (parentPath) {
      // let fileNameList = moveFilesPath.map(item => item.name);
      // let parameter = {
      //   fileNameList,
      //   parentPath,
      //   workspaceId: getWorkspaceId(this)
      // };
      const filePathList = []
      const folderPathList = []
      // let sourceParentPath = '/';
      moveFilesPath.forEach((item) => {
        let path = item.path
        // path = path.replace(/^\/+/, '')
        if (item.folder) {
          folderPathList.push(path)
        } else {
          filePathList.push(path)
        }
      })
      const parameter = {
        filePathList,
        folderPathList,
        // sourceParentPath,
        targetPath: parentPath,
        sourceWorkspaceId: getWorkspaceId(this),
        targetWorkspaceId: getWorkspaceId(this)
      }
      SpaceService.fileExist(parameter).then(res => {
        // console.log(res); || (res.data.sameNameFolders && res.data.sameNameFolders.length > 0)
        if (+res.code === 200) {
          if ((res.data.sameNameFiles && res.data.sameNameFiles.length > 0)) {
            // this.replaceFileHintShow = parentPath
            this.$confirm({
              message: '存在一个或多个文件重名，是否替换？',
              width: 400,
              multipleSubmit: [
                {name: '替换', type: 'primary', key: 'data', value: 1},
                {name: '追加', key: 'data', value: 2},
                {name: '跳过', key: 'data', value: 3}
              ],
              noCancelBtn: true,
              submit: ({data}) => {
                this.fileMove(parentPath, data)
                // console.log(data)
              },
              cancel: () => {
              }
            })
          } else {
            this.fileMove(parentPath)
          }
        } else {
          this.$message.error(res.message || '移动失败！')
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    // 文件替换提示click
    // replaceFileHintBtnClick(val) {
    //   if (val === 'close') {
    //     this.replaceFileHintShow = false
    //     return
    //   }
    //   let value = this.replaceFileHintShow
    //   this.fileMove(value, val)
    //   this.replaceFileHintShow = false
    // },
    // 移动到
    fileMove (val, operationType) {
      const ZJYTOKEN = getCookie('ZJYTOKEN')
      let sourceFileList = []
      let sourceFolderList = []
      moveFilesPath.map(item => {
        if (item.folder) {
          sourceFolderList.push(item.path)
        } else {
          sourceFileList.push(item.path)
        }
      })
      if (sourceFolderList.includes(val)) {
        this.$message.error('移动失败！')
        return
      }
      // 过滤父文件移动到子文件中
      let isSubToSup = false
      sourceFolderList.map((item) => {
        let nowItem = item + '/'
        nowItem = nowItem.replace(/[/]{2,}/g, '/')
        if (val.indexOf(nowItem) > -1) {
          isSubToSup = true
        }
      })
      if (isSubToSup) {
        this.$message.error('移动失败！')
        return
      }
      const cacheKey = new Date().getTime() + '_' + ZJYTOKEN
      let parameter = {
        cacheKey,
        operationType: operationType || 1,
        paramType: 'filePath',
        sourceWorkspaceId: getWorkspaceId(this),
        targetFile: val,
        targetWorkspaceId: getWorkspaceId(this),
        sourceFileList: sourceFileList,
        sourceFolderList: sourceFolderList
      }

      let taskComplete = 0
      let result = null
      const afterTask = () => {
        // 进度到100%、并且有有返回数据时执行
        if (taskComplete && result) {
          if (+result.code === 200 || (taskComplete > 1 && +result.code === -1)) {
            // 操作记录
            // this.recordsDataOpration(7, moveFilesPath);
            this.$message.success('移动成功')
            this.addOperationRecords(7, moveFilesPath)
            initData(this)
          } else if (+result.code === 270014) {
            if (result.data[0].filePath === result.data[0].lockUsers[0].filePath) {
              this.$confirm({
                message: "当前文件或文件夹正在被<em style='color: #1c6ccd;'>" +
                  (result.data[0].lockUsers[0].lockUserName
                    ? result.data[0].lockUsers[0].lockUserName
                    : '其他') +
                  '</em>账号操作，为避免编辑的内容被相互覆盖或文件丢失，暂不可进行此操作，请稍后重试。',
                noCancelBtn: true,
                width: 470
              })
            } else if (result.data[0].filePath.indexOf(result.data[0].lockUsers[0].filePath) !== -1) {
              const projectname = result.data[0].lockUsers[0].filePath.split('/').reverse()[0]
              this.$confirm({
                message: "当前文件或文件夹的父文件夹<em style='color: #1c6ccd;'>（" +
                  projectname +
                  "）</em>正在被<em style='color: #1c6ccd;'>" +
                  (result.data[0].lockUsers[0].lockUserName
                    ? result.data[0].lockUsers[0].lockUserName
                    : '其他') +
                  '</em>账号操作，为避免编辑的内容被相互覆盖，暂不可进行此操作，请稍后重试。',
                noCancelBtn: true,
                width: 470
              })
            } else if (result.data[0].lockUsers[0].filePath.indexOf(result.data[0].filePath) !== -1) {
              const projectname = result.data[0].lockUsers[0].filePath.split('/').reverse()[0]
              this.$confirm({
                message: "当前文件夹下的文件或者文件夹<em style='color: #1c6ccd;'>（" +
                  projectname +
                  "）</em>正在被<em style='color: #1c6ccd;'>" +
                  (result.data[0].lockUsers[0].lockUserName
                    ? result.data[0].lockUsers[0].lockUserName
                    : '其他') +
                  '</em>账号操作，为避免文件丢失，暂不可进行此操作，请稍后重试。',
                noCancelBtn: true,
                width: 470
              })
            }
          } else {
            this.$message.error('移动失败')
          }
          this.topButtonClick('refresh')
        }
      }
      SpaceService.fileMove(parameter).then(res => {
        result = res
        afterTask()
      })
      this.getProgress('move', 1, 'MOVE_FLAG_' + cacheKey, true).then(({hit}) => {
        taskComplete = hit
        afterTask()
      })
    },
    // 移动到取消
    moveCancel () {
      this.moveLayerShow = false
    },
    // 上传
    upload (type) {
      Bus.$emit('openUploader', {
        type: type,
        parameter: {
          workspaceId: getWorkspaceId(this),
          filePath: this.path
        },
        nowPage: this.tabletype === 'companyList' ? 'share' : 'personage',
        moduleName: '工程文件',
        isDataModule: false,
        needRecord: false
      })
    },
    // 搜索
    searchHandle: _.debounce(function (val = '') {
      if (this.searchVal === '' && val === '') {
        return
      }
      // 埋点--搜索
      this.sentLog(this.tabletype === 'companyList' ? 100114002 : 100113020, {message: val})
      // 埋点--搜索
      this.searchVal = val
      if (this.showFileListOfShare) {
        this.getShareFileList(1)
      } else {
        initData(this)
      }
    }, 500),
    // 处理文件类型
    getFileTypeHandle (proT) {
      let extraInfo, extraInfoStr
      if (proT >= 4000) {
        extraInfo = 4
        extraInfoStr = '审核'
      } else if (proT >= 3000) {
        extraInfo = 3
        extraInfoStr = '结算'
      } else if (proT >= 2000) {
        extraInfo = 2
        extraInfoStr = '预算'
      } else if (proT >= 1000) {
        extraInfo = 1
        extraInfoStr = '概算'
      } else {
        extraInfo = 0
        extraInfoStr = '其它'
      }
      return {
        extraInfo,
        extraInfoStr
      }
    },
    // 获取类型
    getFileTypeName (item) {
      if (+item.fileType === 1) {
        return '计价'
      }
      if (+item.fileType === 2) {
        return '计量'
      }
      if (+item.fileType === 3) {
        return '计量协同'
      }
      // } else if (+this.fileType === 1) {
      //   switch (handelTypeVal.extraInfo) {
      //     case 1:
      //       return "概算";
      //     case 2:
      //       return "预算";
      //     case 3:
      //       return "结算";
      //     case 4:
      //       return "审核";
      //   }
      // } else {
      //   return handelTypeVal.extraInfoStr;
      // }
    },
    // 判断 查看模型、预览 操作是否可用
    judgePreview () {
      const item = this.dataList[trIsMouseEnter]
      const nowIcon = this.previewIcon[this.capitalize(item.suffix)]
      if (this.isGTJXT(item)) {
        this.nowPreview.item = item
        this.nowPreview.icon = nowIcon
        return
      } else {
        this.nowPreview.item = item
      }
      let checkedLen = this.dataList.filter(item => {
        return item.checked
      }).length
      if (checkedLen > 1) {
        this.contextMenuDisable.viewModel = true
        this.contextMenuDisable.preview = true
        return
      }
      this.contextMenuDisable.viewModel = true
      this.contextMenuDisable.preview = true
      this.nowPreview.index = trIsMouseEnter
      this.nowPreview.item = {}
      this.nowPreview.icon = {}
      if (nowIcon && nowIcon.suffix) {
        switch (nowIcon.suffix) {
          case 'gtj':
          case 'gtjxt':
          case 'gtjjy':
          case 'gtjxs':
          case 'gdq':
          case 'gqi4':
          case 'gqijy':
          case 'gqixs':
            this.contextMenuDisable.viewModel = false
            break
          default:
            this.contextMenuDisable.preview = false
        }
        this.nowPreview.item = item
        this.nowPreview.icon = nowIcon
      }
    },
    // 判断 是否可以分享
    judgeShare (suffix) {
      let canShare = false
      const canShareSuffix = [
        'gbq5', 'gpb5', 'gpv5', 'gsh5', 'gsc5',
        'gbq7', 'gpb7', 'gpv7', 'gsh7', 'gsc7',
        'gbq6', 'gpb6', 'gpv6', 'gsh6', 'gsc6', 'gbq6jy', 'gpb6jy', 'gpv6jy', 'gsh6jy', 'gsc6jy', 'gbq6xs', 'gpb6xs', 'gpv6xs', 'gsh6xs', 'gsc6xs',
        'gtj', 'gtjjy', 'gtjxs',
        'gqi2', 'gqi3', 'gqi4', 'gqijy', 'gqixs',
        'gma',
        'gjg',
        'gpc5', 'gmt5', 'gcn5', 'ghc5', 'gca5', 'glc5', 'gec5', 'ghw5', 'gwh5', 'gre5'
      ]
      if (suffix && canShareSuffix.indexOf(this.capitalize(suffix)) > -1 && this.tabletype === 'personalList') {
        canShare = true
      }
      // console.log(suffix + ': ' + canShare)
      return canShare
    },
    // 图标hover
    personTextBoxStyleHandle (index) {
      handelTextBoxStyle(this)
      this.iconHoverIndex = index
    },
    // 8. 右键菜单 某一操作项 点击
    contextmenuClick (type) {
      const trItem = this.findSelectItems()
      const {length, fileId, suffix} = this.nowPreview.item
      switch (type) {
        case 'gtjxtmodel':
          if (!this.contextMenuDisable[type]) {
            this.contextMenuShow = false
            this.goGTJXTModel(this.nowPreview.item, true)
          }
          break
        case 'preview':
        case 'viewModel':
          if (this.tabletype === 'companyList') {
            // 共享空间--右键预览
            this.sentLog(100114008, {files: [{fileId, suffix, length, status: 1}], length, status: 1})
          } else {
            // 员工资料库--右键预览
            this.sentLog(100112041, {files: [{fileId, suffix, length, status: 1}], length, status: 1})
          }
          let item = this.nowPreview.item
          if (item.icons && item.icons && item.icons.toUpperCase() === 'GTJXT') {
            this.preview(item, this.previewIcon['gtj'], 3)
            let projectid = this.$route.query.prjId
            let prjname = this.$route.query.prjName
          } else if (!this.contextMenuDisable[type]) {
            this.contextMenuShow = false
            if (this.showFileListOfShare) {
              this.shareFileActionEmitter('preview', trItem)
            } else {
              this.preview(this.nowPreview.item, this.nowPreview.icon, 3)
            }
          }
          break
        case 'rename':
          this.fileRename(this.nowPreview.index, this.nowPreview.item.name)
          break
        case 'download': // 下载 (收到的分享工程文件)
          if (this.showFileListOfShare && !this.contextMenuDisable[type] && trItem) {
            this.shareFileActionEmitter(type, trItem)
          }
          break
        case 'unloading': // 转存到我的空间 (收到的分享工程文件)
          if (this.showFileListOfShare && !this.contextMenuDisable[type] && trItem) {
            this.saveShareFile(trItem)
          }
          break
        case 'delete':
          this.deleteShareFileConfirm(deleteFileList)
          break
        default:
      }
    },
    // 9. 右键菜单 状态设置
    setContextMenuStatus () {
      if (this.showFileListOfShare) { // 我收到的分享工程 文件夹内
        this.contextMenuDisable.viewModel = true
        this.contextMenuDisable.preview = true
        this.contextMenuDisable.download = true
        this.contextMenuDisable.unloading = true
        this.contextMenuDisable.delete = false // 能批量删除
        if (this.checkedLen === 1) {
          let checkedItem = null
          this.dataList.forEach((item) => {
            if (item.checked) {
              checkedItem = item
            }
          })
          if (checkedItem) {
            // 如果只选择了一个收到的分享工程 且 还在有效期内 右键菜单 可下载、转存、GTJ文件能模型预览、GBQ5,GBQ6文件能预览
            if (checkedItem.remainTime === null || +checkedItem.remainTime > 0) {
              this.contextMenuDisable.download = false
              this.contextMenuDisable.unloading = false
              // 未加密文件 右键菜单 预览 才不置灰
              if (checkedItem.suffix && !checkedItem.isEncrypt) {
                if (/gbq[56]/i.test(checkedItem.suffix)) {
                  this.contextMenuDisable.preview = false
                }
              }
            }
          }
        }
      } else { // 其他 文件夹内
        if (this.checkedLen > 1) {
          this.contextMenuDisable = {
            viewModel: true,
            preview: true,
            download: false,
            delete: false,
            copyToCompanySpace: true,
            move: false,
            rename: true,
            share: true,
            copy: false
          }
        } else {
          this.contextMenuDisable = {
            viewModel: true,
            preview: true,
            download: false,
            delete: false,
            copyToCompanySpace: false,
            move: false,
            rename: false,
            share: true,
            copy: false
          }
        }
      }
    },
    // 10. 设置右键菜单列表状态 和 顶部操作按钮组
    setContextmenuStatusAndTopButtons () {
      this.checkedLen = this.dataList.filter(item => {
        return item.checked
      }).length
      // 设置 右键菜单列表 置灰状态
      this.setContextMenuStatus()
      // 设置 顶部操作按钮组
      if (this.showFileListOfShare) { // 我收到分享工程 文件夹内
        if (this.checkedLen > 0) {
          this.buttonList = ['refresh', 'delete']
        } else {
          this.buttonList = ['refresh']
        }
      } else { // 其他 文件夹内
        if (this.checkedLen > 0) {
          if (this.tabletype === 'companyList' && !this.isModuleAdmin && !this.permission) { // 员工 查看 共享空间
            this.buttonList = ['upload', 'refresh', 'download']
          } else { // 员工 查看自己的空间 or 管理员 查看共享空间 or 项目库
            this.buttonList = ['upload', 'addFolder', 'refresh', 'download', 'move', 'delete'] // , 'cancel'
            if (this.tabletype === 'personalList') { // 员工 查看自己的空间
              // TODO: 2020.6.10 除管理员、个人账号外都可以复制到企业共享工具  this.user.userType === 3 缓存 [2,3,4].includes(this.user.role)
              //  删除按钮前面 多一个 “复制到共享空间按钮”
              this.buttonList.splice(5, 0, 'copyToCompanySpace')
            }
          }
        } else {
          if (this.tabletype === 'companyList' && !this.isModuleAdmin && !this.permission) { // 员工 查看 共享空间
            this.buttonList = ['upload', 'addFolder', 'refresh']
          } else { // 员工 查看自己的空间 or 管理员 查看共享空间 or 项目库
            this.buttonList = ['upload', 'addFolder', 'refresh']
          }
        }
      }
      // 列表展示 搜索出来的文件时 去掉 新建文件夹 按钮
      if (this.searchVal) {
        if (this.buttonList.indexOf('addFolder') > -1) {
          this.buttonList.splice(this.buttonList.indexOf('addFolder'), 1)
        }
      }
    },
    /*  我收到的分享工程 相关 */
    // 11.0 我收到的分享工程 获取文件列表
    getShareFileList (init) {
      this.showFileListOfShare = true
      this.isCheckAll = false
      if (init) {
        this.pageNum = 1
        this.total = 0
        // this.searchVal = ''
        this.dataList = []
        // let otherHeight = 45 + 55 + 100 + 40
        // this.setTableHeight(otherHeight)
      }
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        search: this.searchVal
      }
      SpaceService.getShareFileList(params).then(res => {
        // console.log(res)
        if (+res.code === 200 && res.data) {
          const list = res.data.items || []
          list.map((item) => {
            item.checked = false
            if (item.isEncrypt === null || item.isEncrypt === 'true' || item.isEncrypt === true || +item.isEncrypt === 1) {
              item.isEncrypt = true
            } else {
              item.isEncrypt = false
            }
            //  获取文件后缀
            if (item.fileName) {
              const reg = /[^.]+\.([a-z0-9]+)$/i
              const matchedArr = reg.exec(item.fileName)
              if (matchedArr && matchedArr[1]) {
                item.suffix = this.capitalize(matchedArr[1])
              }
            }
            item.size = sizeConver(item.fileSize || 0)
            if (item.shareTime) {
              item.shareTimeStr = formatDay(new Date(item.shareTime))
            }
            const canPreviewSuffix = ['gbq5', 'gbq6', 'gbq7'] // , 'gtj'
            // gbq5,6 加密文件 不可预览
            if (!item.isEncrypt && item.suffix && canPreviewSuffix.indexOf(item.suffix) > -1) {
              item.canPreview = true
            }
            // item.remainTime = 0
            if (item.remainTime === null) {
              item.invalid = false // 该分享 永久有效
              item.remainTimeStr = '永久有效'
            } else {
              if (+item.remainTime <= 0) {
                item.invalid = true // 该分享已失效
                item.remainTimeStr = '已失效'
              } else {
                item.invalid = false // 该分享 处在有效期内
                item.remainTimeStr = formatDuration(+item.remainTime, '', {noMillisecond: true})
              }
            }
          })
          this.dataList = list
          this.total = res.data.totalCount || 0
        } else {
          this.$message.error(res.message)
          this.dataList = []
        }
      })
    },
    // 11.1 我收到的分享工程 删除
    deleteShareFileConfirm (arr) {
      this.$confirm({
        message: '确定删除',
        tips: '确定要把文件删除？',
        tipsRed: '删除将无法找回！',
        dealData: arr,
        submit: (data) => {
          this.shareFileActionEmitter('delete', data).then(res => {
            if (+res.code === 200 && res.data === true) {
              this.$message.success('删除成功!')
              this.getShareFileList(1)
            } else {
              this.$message.error(res.message)
            }
          }).catch((e) => {
            console.log(e)
            this.$message.error('删除失败')
          })
        },
        submitText: '确定'
      })
    },
    // 11.2 我收到的分享工程 转存到我的空间
    saveShareFile (item) {
      this.shareFileActionEmitter('unloading', item).then(res => {
        if (+res.code === 200) {
          this.$confirm({
            message: '保存成功',
            noCancelBtn: true,
            submit: () => {
              // 刷新文件
              this.topButtonClick('refresh')
            },
            submitText: '确定'
          })
        } else {
          this.$message.error(res.message ? res.message : '保存失败')
        }
      }).catch(() => {
        this.$message.error('保存失败')
      })
    },
    // 点击进入所在目录
    handleDirectoryClick (item) {
      const {fileId, path} = item
      const spaceType = this.tabletype === 'companyList' ? 2 : 1
      this.directoryJump({
        fileId,
        filePath: path.substring(0, path.lastIndexOf('/')),
        workspaceId: getWorkspaceId(this),
        spaceType,
        path: this.$route.path
      }).then(() => {
        this.$refs.operationSearch.clear()
        // this.searchVal = ''
        // initData(this)
      })
    }
  },
  beforeDestroy () {
    Bus.$off('SpaceFileListReload')
    if (this.tabletype === 'personalList') {
      Bus.$off('refreshList')
    }
    initEvent(this)
  },
  mounted () {
    let _self = this
    Bus.$on('SpaceFileListReload', query => {
      initData(_self)
    })
    if (this.tabletype === 'personalList') {
      Bus.$on('refreshList', query => {
        initData(_self)
      })
    }
    setTimeout(() => {
      this.calcTableHeight()
    }, 200)
    // 窗口大小改变时 触发
    this.resizeHandle.resize(this.calcTableHeight)
    this.pathItems = [{name: `${this.getPathNameG()}`}]
  },
  created () {
    this.isModuleAdmin = this.hasModuleAuth('zjy_module_gxzlk_gxzl_manage')
    let userinfo = getCookie('ZJYUSERINFO')
    if (userinfo) {
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
    if (this.tabletype === 'projectList') {
      this.pathItems[0].name = this.$route.query.prjName
      this.path = '/' + this.$route.query.prjName
    }
    // console.log(this.iconListKey)
    // console.log('00000000000000000')
    if (+this.guideType === 4 || +this.guideType === 5) {
      this.setPersonalTypeFilter({fileType: 0, listType: 'list'})
      this.setEnterproseTypeFilter({fileType: 0, listType: 'list'})
      localStorage.setItem('personalFileType', 0)
      localStorage.setItem('companyFileType', 0)
    }
    // 选定列表类型
    getFileType(this)
    // 初始化事件
    setTimeout(() => {
      initEvent(this, true)
    }, 100)
    if (this.iconListKey) {
      initData(this, true)
    }
    this.getTypeFilterData()
    if (this.tabletype === 'companyList' && !this.isModuleAdmin && !this.permission) {
      this.buttonList = ['upload', 'refresh']
    }
  }
}
const eventList = [
  'keydown',
  'keyup',
  'mousedown',
  'mousemove',
  'mouseup',
  'click',
  'dragleave',
  'dragenter',
  'dragover',
  'drop'
]
const eventObj = {}
eventList.forEach((name) => {
  eventObj[name] = null
})

// 初始化事件
function initEvent (that, init) {
  // console.log('=============================', init)
  let _self = that
  // 先销毁事件
  eventList.forEach((name) => {
    if (eventObj[name]) {
      // console.log(name)
      off(document, name, eventObj[name])
      eventObj[name] = null
    }
  })
  if (!init) return
  eventObj.keydown = function (e) {
    if (!_self.isRaname) {
      if (e.keyCode === 16) {
        isOnShift = true
      } else if (e.keyCode === 17) {
        isOnCtrl = true
      }
    }
  }
  on(document, 'keydown', eventObj.keydown)

  eventObj.keyup = function (e) {
    if (!_self.isRaname) {
      isOnShift = false
      isOnCtrl = false
    }
  }
  on(document, 'keyup', eventObj.keyup)

  eventObj.mousedown = function (e) {
    // 如果有重命名弹框，取消触发事件
    if (!_self.isRaname) {
      if (trIsMouseEnter > -1) {
        isDownSel = true
        if (mouserEnterItemIndex !== -1) {
          try {
            isDown = _self.dataList[mouserEnterItemIndex].checked
          } catch (error) {
          }
        }
        starX = e.clientX
        starY = e.clientY
      }
    }
    //   isDown = true;
  }
  on(document, 'mousedown', eventObj.mousedown)

  eventObj.mousemove = function (e) {
    // 如果有重命名弹框，取消触发事件
    if (!_self.isRaname) {
      e.stopPropagation()
      e.preventDefault()
      if (isDown) {
        if (!isAddBox && (Math.abs(e.clientX - starX) > 10 || Math.abs(e.clientY - starY) > 10)) {
          isAddBox = true
        }
        if (!isAddBox) {
          return
        }
        //   if (USER_TYPE === 2 && spaceType) {
        //     return;
        //   }
        let mydragIconDom = document.querySelector('.mydrag-icon')
        mydragIconDom.style.left = e.clientX + 10 + 'px'
        mydragIconDom.style.top = e.clientY + 10 + 'px'
        // 我收到的分享工程 文件夹内 不现实 拖拽移动、其他文件夹内显示
        if (!_self.showFileListOfShare) {
          _self.mydragIconShow = true
        }

        if (event.preventDefault) {
          event.preventDefault()
        }
        return false
      } else if (isDownSel) {
        if (!isAddBox && (Math.abs(e.clientX - starX) > 10 || Math.abs(e.clientY - starY) > 10)) {
          isAddBox = true
        }
        if (!isAddBox) {
          return
        }
        if (!_self.mydragSelShow) {
          _self.mydragSelShow = true
          return
        }
        let _x = e.clientX || e.x
        let _y = e.clientY || e.y
        let mydragSel = document.querySelector('.mydrag-sel')
        mydragSel.style.left = Math.min(_x, starX) + 'px'
        mydragSel.style.top = Math.min(_y, starY) + 'px'
        mydragSel.style.width = Math.abs(e.clientX - starX) + 'px'
        mydragSel.style.height = Math.abs(e.clientY - starY) + 'px'

        let _l = mydragSel.offsetLeft
        let _t = mydragSel.offsetTop
        let _w = mydragSel.clientWidth
        let _h = mydragSel.clientHeight

        let projectTabCnt = document.querySelector('#projectTabCnt')
        let tableBodyWrapper = that.typeFilterData === 'list' ? that.tabletype === 'projectList' ? document.getElementsByClassName('table-body-wrapper')[1] : document.querySelector('.table-body-wrapper') : document.querySelector('.listcnt')
        let projectTabOffSetLeft = projectTabCnt.offsetLeft
        let tablieBodyScrollTop = tableBodyWrapper
          ? tableBodyWrapper.scrollTop
          : 0
        let projectTabOffSetTop =
          projectTabCnt.offsetTop + 40 - tablieBodyScrollTop
        let trlist = document.querySelectorAll('.trItem')
        for (let i = 0; i < trlist.length; i++) {
          let item = trlist[i]
          let sl = item.clientWidth + item.offsetLeft + projectTabOffSetLeft
          let st = item.clientHeight + item.offsetTop + projectTabOffSetTop
          let dataobj = {..._self.dataList[i]}
          if (sl > _l && st > _t && item.offsetLeft + projectTabOffSetLeft < _l + _w &&
            item.offsetTop + projectTabOffSetTop < _t + _h) {
            // console.log('projectTabOffSetTop:' + projectTabOffSetTop)
            // console.log('item.offsetTop:' + item.offsetTop)
            // console.log('_t + _h:' + _t + _h)
            // console.log('st:' + st)
            // console.log('_t:' + _t)
            if (!dataobj.checked) {
              // 我收到的分享工程 文件夹 不可框选
              if (dataobj.fileType !== 'share' && !_self.isGTJXT(dataobj)) {
                console.log(i)
                console.log(dataobj)
                dataobj.checked = true
              }
              _self.dataList.splice(i, 1, dataobj)
            }
          } else {
            if (dataobj.checked) {
              dataobj.checked = false
              _self.dataList.splice(i, 1, dataobj)
            }
          }
        }
      }
      _self.$nextTick(() => {
        if (_self.checkedLen === 0) {
          _self.contextMenuDisable = {
            viewModel: true,
            preview: true,
            download: true,
            delete: true,
            copyToCompanySpace: true,
            move: true,
            rename: true,
            copy: true,
            noShare: true
          }
        }
      })
    }
  }
  on(document, 'mousemove', eventObj.mousemove)

  eventObj.mouseup = function (e) {
    if (!_self.isRaname) {
      // console.log('1111111111111')
      // console.log(isAddBox)
      // console.log(trIsMouseEnter)
      if (isAddBox && trIsMouseEnter > -1) {
        if (_self.dataList[trIsMouseEnter] && !_self.dataList[trIsMouseEnter].checked && _self.dataList[trIsMouseEnter].folder) {
          // 选择文件 拖拽移动到 “我收到的分享工程” 文件夹时 提示不能移动到此文件夹
          if (_self.dataList[trIsMouseEnter].fileType === 'share') {
            _self.$message.warning('系统文件夹，不支持操作')
          } else {
            moveFilesPath = _self.dataList.filter(item => item.checked)
            _self.moveAffirm(_self.dataList[trIsMouseEnter].path)
            if (_self.tabletype === 'personalList') {
              _self.sentLog(100113013, {count: moveFilesPath.length})
            }
          }
        }
      }
      isDown = false
      isDownSel = false
      isAddBox = false
      _self.mydragSelShow = false
      _self.mydragIconShow = false
      // console.log(e);
    }
  }
  on(document, 'mouseup', eventObj.mouseup)

  eventObj.click = function (e) {
    if (!_self.isRaname) {
      if (_self.contextMenuShow) {
        _self.contextMenuShow = false
      }
    }
  }
  on(document, 'click', eventObj.click)

  setTimeout(() => {
    let trlistDom = document.querySelector('#projectTabCnt')
    on(trlistDom, 'contextmenu', function (e) {
      if (trIsMouseEnter > -1) {
        e = e || window.event
        e.stopPropagation()
        e.preventDefault()
        let _x = e.clientX || e.x
        let _y = e.clientY || e.y
        let contextMenuDom = document.querySelector('.contextMenu')
        contextMenuDom.style.left = 'auto'
        contextMenuDom.style.right = 'auto'
        contextMenuDom.style.top = 'auto'
        contextMenuDom.style.bottom = 'auto'

        let maxWidth = document.body.clientWidth
        if (maxWidth - _x <= 130) {
          contextMenuDom.style.right = '8px'
        } else {
          contextMenuDom.style.left = _x + 10 + 'px'
          if (_self.isMicro || getCookie('GEIPTOKEN')){
            contextMenuDom.style.left = _self.isAsideExpand ? _x + 10 - 216 + 'px' : _x + 10 + 'px'
          }
        }
        let maxHeight = document.body.clientHeight
        if (maxHeight - _y <= 260) {
          contextMenuDom.style.bottom = '8px'
        } else {
          contextMenuDom.style.top = _y + 10 + 'px'
          if (_self.isMicro || getCookie('GEIPTOKEN')){
            contextMenuDom.style.top = _y + 10 - 98 + 'px'
          }
        }

        // contextMenuDom.style.left = _x + 10 + 'px'
        // contextMenuDom.style.top = _y + 10 + 'px'
        let dataList = JSON.parse(JSON.stringify(_self.dataList))
        // 我收到的分享工程 文件夹 右键菜单 全部置灰
        if (_self.isGTJXT(dataList[trIsMouseEnter])) {
          _self.contextMenuDisable = {
            viewModel: false,
            preview: true
          }
          // _self.judgeGTJXT()
          _self.judgePreview()
          _self.contextMenuShow = true
          return
        } else if (+trIsMouseEnter === 0 && dataList[trIsMouseEnter] && dataList[trIsMouseEnter].fileType === 'share') {
          _self.contextMenuDisable = {
            viewModel: true,
            preview: true,
            download: true,
            delete: true,
            copyToCompanySpace: true,
            move: true,
            rename: true,
            copy: true,
            noShare: true
          }
          _self.contextMenuShow = true
          return
        } else {
          _self.contextMenuDisable.noShare = false
          _self.contextMenuDisable.delete = false
          _self.contextMenuDisable.download = false
          _self.contextMenuDisable.copyToCompanySpace = false
          _self.contextMenuDisable.move = false
        }
        let nowIcon = {}
        if (!dataList[trIsMouseEnter].checked) {
          dataList.forEach((item, index) => {
            if (trIsMouseEnter === index) {
              nowIcon = item
              item.checked = true
            } else {
              item.checked = false
            }
          })
          _self.dataList = dataList
        } else {
          nowIcon = dataList[trIsMouseEnter]
        }
        _self.$nextTick(() => {
          _self.judgePreview()
          let checkedCount = 0
          dataList.forEach((item, index) => {
            if (item.checked) {
              checkedCount++
            }
          })
          // 如果是多选时 右键菜单 分享置灰
          _self.$set(_self.contextMenuDisable, 'share', true)
          // console.log(nowIcon.suffix)
          if (checkedCount === 1 && _self.judgeShare(nowIcon.suffix)) {
            /* 当只选择了某一个文件时  判断当前行文件 是否可以分享 */
            _self.$set(_self.contextMenuDisable, 'share', false)
          }
          // 我收到的分享工程 文件内 右键菜单 置灰状态设置
          if (_self.showFileListOfShare) {
            _self.setContextMenuStatus()
          }
          _self.contextMenuShow = true
        })
      }
    })

    let dragFilebox = document.querySelector('.dndCnt')
    on(document, 'dragleave', eventObj.dragleave = function (e) {
      e.preventDefault()
      e.stopPropagation()
      if (_self.showFileListOfShare) {
        return false
      }
      var handler
      handler = function () {
        _self.drawFileShow = false
      }
      clearTimeout(_self._leaveTimer)
      _self._leaveTimer = setTimeout(handler, 100)
      return false
    })
    on(document, 'dragenter', eventObj.dragenter = function (e) {
      e.preventDefault()
      e.stopPropagation()
      if (_self.showFileListOfShare) {
        return false
      }
      _self.drawFileShow = true
      return false
    })
    on(document, 'dragover', eventObj.dragover = function (e) {
      e.preventDefault()
      e.stopPropagation()
      if (_self.showFileListOfShare) {
        return false
      }
      clearTimeout(_self._leaveTimer)
      _self.drawFileShow = true
      return false
    })
    on(document, 'drop', eventObj.drop = function (e) {
      e.preventDefault()
      e.stopPropagation()
      if (_self.showFileListOfShare) {
        return false
      }
      _self.drawFileShow = false
      return false
    })
    on(dragFilebox, 'drop', function (e) {
      e.preventDefault() // 取消默认浏览器拖拽效果
      e.stopPropagation()
      if (_self.showFileListOfShare) {
        return false
      }
      let fileList = e.dataTransfer.files // 获取文件对象
      _self.drawFileShow = false
      if (fileList.length === 0) {
        return
      }
      let dataTransfer = e.dataTransfer
      let items = dataTransfer.items
      let files = dataTransfer.files
      let canAccessFolder = !!(items && items[0].webkitGetAsEntry)
      let results = []
      let len = files.length
      let promises = []

      for (let i = 0; i < len; i++) {
        let file = files[i]
        let item = items && items[i]
        if (canAccessFolder && item.webkitGetAsEntry().isDirectory) {
          promises.push(
            _traverseDirectoryTree(item.webkitGetAsEntry(), results)
          )
          console.log(floderFiles)
        } else {
          results.push(file)
        }
      }

      if (promises.length > 0) {
        Promise.all(promises).then(res => {
          let posilist = _handleDataFile(res)
          let files = [...results, ...posilist]
          if (files.length > 100) {
            _self.$message.warning('文件过多，一次最多可以上传100个文件')
            return
          }
          Bus.$emit('addUploaderFiles', {
            files: files,
            parameter: {
              drag: true, // 拖拽上传
              workspaceId: getWorkspaceId(_self),
              filePath: _self.path
            }
          })
        })
      } else {
        if (results.length > 100) {
          _self.$message.warning('文件过多，一次最多可以上传100个文件')
          return
        }
        Bus.$emit('addUploaderFiles', {
          files: [...results],
          parameter: {
            drag: true, // 拖拽上传
            workspaceId: getWorkspaceId(_self),
            filePath: _self.path
          }
        })
      }
    })
  }, 200)
}

function _handleDataFile (res) {
  let main = [];
  (function _gData (data) {
    data.map(item => {
      if (Array.isArray(item)) {
        _gData(item)
      } else {
        main.push(item)
      }
    })
  })(res)
  return main
}

function _traverseDirectoryTree (entry, results, isDirectory) {
  return new Promise((resolve, reject) => {
    if (entry.isFile) {
      entry.file(function (file) {
        if (isDirectory) {
          file.fullPath = entry.fullPath
        }
        // results.push( file );
        resolve(file)
      })
    } else if (entry.isDirectory) {
      let promises = []
      let _dirReader = entry.createReader();
      (function _readEntries (_dirReader1) {
        _dirReader1.readEntries(function (entries) {
          var len = entries.length
          // var arr = []; // 为了保证顺序。
          var i
          //
          for (i = 0; i < len; i++) {
            promises.push(_traverseDirectoryTree(entries[i], [], true))
          }
          if (len === 100) {
            _readEntries(_dirReader1)
          } else {
            Promise.all(promises).then(res => {
              resolve(res)
            })
          }
        })
      })(_dirReader)
    }
  })
}

// 获取空间id
function getWorkspaceId (that, company) {
  if (that.tabletype === 'companyList' || company) {
    return getCookie('enterpriseWorkspaceIdValue')
  }
  if (that.tabletype === 'personalList') {
    return getCookie('personalWorkspaceIdValue')
  }
  if (that.tabletype === 'projectList') {
    return getCookie('projectWorkspaceIdValue')
  }
}

function getWorkspaceIdByType (type) {
  if (type === 'personal') {
    return getCookie('personalWorkspaceIdValue')
  }
  if (type === 'company') {
    return getCookie('enterpriseWorkspaceIdValue')
  }
  if (type === 'project') {
    return getCookie('projectWorkspaceIdValue')
  }
}

// 获取fileType
function getFileType (that) {
  // 个人空间
  // if (that.tabletype === "personalList") {
  //   that.fileType = that.personalFilter.fileType;
  //   return that.personalFilter.fileType;
  // }
  // 企业空间
  // if (that.tabletype === "companyList") {
  //   that.fileType = that.enterpriseFilter.fileType;
  //   return that.enterpriseFilter.fileType;
  // }
  // 项目库
  // if (that.tabletype === "projectList") {
  //   that.fileType = that.projectFilter.fileType;
  //   return that.projectFilter.fileType;
  // }

  // 文件类型需要存入localstorage中
  let fileType
  switch (that.tabletype) {
    case 'personalList':
      fileType = localStorage.getItem('personalFileType') || 0
      break
    case 'companyList':
      fileType = localStorage.getItem('companyFileType') || 0
      break
    case 'projectList':
      fileType = localStorage.getItem('projectFileType') || 0
      break
    default:
      fileType = 0
      break
  }
  fileType = fileType - 0
  that.fileType = fileType
  return fileType
}

// 初始化数据
function initData (that, resetPager) {
  // that.dataList = [];
  if (!resetPager) {
    // console.log("reset project table pager");
    that.pageNum = 1
    that.pageSize = 50
    that.total = 0
  }
  // 2021.3.19 ker 从工作台跳转，路由携带有分页或者目录路径时 -- start
  let query = that.$route.query
  const {pageNum, paths = ''} = query
  if (pageNum && /^[0-9]*$/.test(pageNum)) {
    that.pageNum = Number(query.pageNum)
    that.pageSize = 50
  }
  if (paths) {
    let pathItems = [{name: '全部文件'}]
    that.path = '/' + paths
    paths.split('/').forEach(path => {
      pathItems.push({name: path})
    })
    that.pathItems = pathItems
  }
  // let query = that.$route.query
  // if (!isEmptyObject(query)) {
  //   const {pageNum = 1, pageSize = 50, paths = ''} = query
  //   that.pageNum = Number(pageNum)
  //   that.pageSize = Number(pageSize)
  //   let pathItems = [{name: '全部文件'}]
  //   if (paths) {
  //     that.path = '/' + paths
  //     paths.split('/').forEach(path => {
  //       pathItems.push({name: path})
  //     })
  //   }
  //   that.pathItems = pathItems
  // }
  // 2021.3.19 ker 从工作台跳转，路由携带有分页或者目录路径时 -- end
  if (that.tabletype === 'projectList') {
    if (that.path === '/') {
      that.path = '/' + that.$route.query.prjName
    } else if (that.path.indexOf('/' + that.$route.query.prjName) !== 0) {
      that.path = '/' + that.$route.query.prjName + that.path
    }
  }
  let parameter = {
    path: that.path,
    workspaceId: getWorkspaceId(that),
    fileType: getFileType(that),
    sortFieldName: that.sortFieldName,
    sortType: that.sortType,
    pageNum: that.pageNum,
    pageSize: that.pageSize
  }
  let apiName = 'getFileList'
  if (that.searchVal) {
    apiName = 'getSearchFileList'
    parameter.searchCondition = `{
      name: ${that.searchVal}
    }`
  }
  // 个人空间、企业员工自己的空间 在根目录下 显示 我收到的分享工程 文件夹
  if (that.path === '/' && that.tabletype === 'personalList') {
    parameter.needShare = true
  }
  that.loading = true
  SpaceService[apiName](parameter).then(res => {
    that.loading = false
    that.renameData = {
      suffix: '',
      value: '',
      showIndex: -1
    }
    that.renameOk = false
    that.isRaname = false
    // console.log("getFileList====>", res);
    // 2019.12.9 === start
    // if (+res.code === 200) {
    //   if (res.data.items) {
    //     res.data.items.forEach(item => {
    //       item.size = sizeConver(item.length);
    //       if (item.createTime) {
    //         item.createTime = formatDay(new Date(parseInt(item.createTime)));
    //       }
    //       if (item.modifyTime) {
    //         item.modifyTime = formatDay(new Date(parseInt(item.modifyTime)));
    //       }
    //       if (
    //         +item.fileType === 1 &&
    //         item.fileProperties &&
    //         item.fileProperties.projectType
    //       ) {
    //         item.extraInfo = that.getFileTypeHandle(
    //           item.fileProperties.projectType
    //         ).extraInfo;
    //       }
    //     });
    //     that.isCheckAll = false;
    //     that.dataList = getFileTyeIconClass(res.data.items);
    //     that.total = res.data.totalCount;
    //     setTimeout(() => {
    //       handelTextBoxStyle(that);
    //     }, 300);
    //   }
    // }
    // 2019.12.9 === end
    let data = res.data || {}
    let items = data.items || []
    let totalCount = data.totalCount || 0
    items.forEach(item => {
      item.size = sizeConver(item.length || 0)
      if (item.createTime) {
        item.createTime = formatDay(new Date(parseInt(item.createTime)))
      }
      if (item.modifyTime) {
        item.modifyTime = formatDay(new Date(parseInt(item.modifyTime)))
      }
      // 我收到的分享工程文件夹 是虚拟文件夹 fileProperties 属性为 null 若不设置成对象 html 中会报错
      if (!item.fileProperties) {
        item.fileProperties = {}
      }
      if (+item.fileType === 1 && item.fileProperties.projectType) {
        item.extraInfo = that.getFileTypeHandle(item.fileProperties.projectType).extraInfo
      }
    })
    that.isCheckAll = false
    that.dataList = getFileTyeIconClass(items)
    that.total = totalCount
    that.calcTableHeight()
    setTimeout(() => {
      handelTextBoxStyle(that)
    }, 300)
    // 2021.3.19 从工作台跳转
    that.$nextTick(() => {
      if (query.fileId) {
        let scrollElement = document.getElementById(query.fileId)
        scrollElement && scrollElement.scrollIntoView()
        that.$router.replace(that.$route.path)
      }
    })
    // 2021.3.19 从工作台跳转
  }).catch(() => {
    that.loading = false
  })
}

// 删除文件
function delFiles (that) {
  if (deleteFileList.length === 0) {
    return
  }
  SpaceService.deleteFile({
    pathList: deleteFileList.map(item => item.path),
    workspaceId: getWorkspaceId(that)
  }).then(result => {
    // console.log("getFileList====>", res);
    if (+result.code === 200) {
      // that.recordsDataOpration(2, deleteFileList);
      that.addOperationRecords(2, deleteFileList)
      initData(that)
      that.$message.success('删除成功')

    } else if (+result.code === 270014) {
      if (result.data[0].filePath === result.data[0].lockUsers[0].filePath) {
        that.$confirm({
          message: "当前文件或文件夹正在被<em style='color: #1c6ccd;'>" +
            (result.data[0].lockUsers[0].lockUserName
              ? result.data[0].lockUsers[0].lockUserName
              : '其他') +
            '</em>账号操作，为避免编辑的内容被相互覆盖或文件丢失，暂不可进行此操作，请稍后重试。',
          noCancelBtn: true,
          width: 470
        })
      } else if (result.data[0].filePath.indexOf(result.data[0].lockUsers[0].filePath) !== -1) {
        const projectname = result.data[0].lockUsers[0].filePath
          .split('/')
          .reverse()[0]
        that.$confirm({
          message: "当前文件或文件夹的父文件夹<em style='color: #1c6ccd;'>（" +
            projectname +
            "）</em>正在被<em style='color: #1c6ccd;'>" +
            (result.data[0].lockUsers[0].lockUserName
              ? result.data[0].lockUsers[0].lockUserName
              : '其他') +
            '</em>账号操作，为避免编辑的内容被相互覆盖，暂不可进行此操作，请稍后重试。',
          noCancelBtn: true,
          width: 470
        })
      } else if (result.data[0].lockUsers[0].filePath.indexOf(result.data[0].filePath) !== -1) {
        const projectname = result.data[0].lockUsers[0].filePath
          .split('/')
          .reverse()[0]
        that.$confirm({
          message: "当前文件夹下的文件或者文件夹<em style='color: #1c6ccd;'>（" +
            projectname +
            "）</em>正在被<em style='color: #1c6ccd;'>" +
            (result.data[0].lockUsers[0].lockUserName
              ? result.data[0].lockUsers[0].lockUserName
              : '其他') +
            '</em>账号操作，为避免文件丢失，暂不可进行此操作，请稍后重试。',
          noCancelBtn: true,
          width: 470
        })
      }
    } else {
      that.$message.error('删除失败！')
    }
  }).catch((e) => {
    console.log(e)
  })
}

// 获取下载状态
function getDownloadFilesState (that, zipFileName, additional) {
  const {logData} = additional
  SpaceService.getDownloadFilesState().then(res => {
    // console.log("downloadFiles====>", res);
    clearTimeout(downLoadTimer)
    if (+res.code === 200) {
      // console.log(res.data);
      if (res.data >= 100) {
        setTimeout(() => {
          // console.log('123')
          that.$progress({closeAll: true})
        }, 100)
        logData.extJson.files.forEach(item => {
          item.status = 1
        })
        that.sentLog(logData.fnCode, logData.extJson)
        // that.downloadProgressLaterShow = false;
        // that.downloadProgressValue = parseInt(res.data);
        that.showProgress('正在下载文件...', +res.data)
        let token = getCookie('ZJYTOKEN')
        const geipToken = getCookie('GEIPTOKEN') || ''
        zipFileName = encodeURIComponent(zipFileName)
        window.common.downloadFile(
          `${backendUrl}/file/batch_download?zipFileName=${zipFileName}&token=${token}&geipToken=${geipToken}`
        )
      } else if (+res.data === -1) {
        that.sentLog(logData.fnCode, Object.assign(logData.extJson, {code: res.code}))
        // that.downloadProgressValue = 0;
        // that.downloadProgressLaterShow = false;
        // alert('下载失败')
        that.$progress({
          closeAll: true,
          close: () => {
            that.$message.error('下载失败')
          }
        })
      } else {
        // that.downloadProgressValue = parseInt(res.data);
        that.showProgress('正在下载文件...', +res.data)
        downLoadTimer = setTimeout(() => {
          getDownloadFilesState(that, zipFileName, additional)
        }, 1000)
      }
    }
  })
}

// 创建文件夹
function createdFolder (that) {
  let queryinput = document.querySelector('.renameInput')
  if (that.isRaname && queryinput) {
    setTimeout(() => {
      queryinput.setSelectionRange(0, queryinput.value.length)
      queryinput.focus()
    }, 100)
    return
  }
  that.renameData = {
    suffix: '',
    value: '',
    showIndex: 0
  }
  that.renameOk = false
  const newFolderItem = {
    isCreateFolder: 1,
    value: '',
    folder: true,
    fileProperties: {},
    icons: 'iconfolders'
  }
  let datalist = JSON.parse(JSON.stringify(that.dataList))
  if (datalist[0] && datalist[0].fileType === 'share') {
    // 若文件列表第一个为 “我收到的分享工程” 文件夹时 新建文件夹放在它后面
    if (datalist.length === 1) {
      datalist.push(newFolderItem)
    } else {
      datalist.splice(1, 0, newFolderItem)
    }
    that.renameData.showIndex = 1 // 新建文件夹 使文件列表第二个 显示名称输入
  } else {
    datalist.unshift(newFolderItem)
  }
  that.renameData.value = '新建文件夹'
  that.isRaname = true
  that.dataList = datalist
  setTimeout(() => {
    let queryinput = document.querySelector('.renameInput')
    queryinput.setSelectionRange(0, queryinput.value.length)
    queryinput.focus()
  }, 100)
}

//
function handelTextBoxStyle (that) {
  let personTextboxAll
  if (that.typeFilterData === 'list') {
    personTextboxAll = document.querySelectorAll('.trItem')
  } else {
    personTextboxAll = document.querySelectorAll('.imgItem')
  }
  let w =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth
  let h =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight

  let tableBodyWrapper = that.typeFilterData === 'list' ? document.querySelector('.table-body-wrapper') : document.querySelector('.listcnt')
  let tablieBodyScrollTop = tableBodyWrapper ? tableBodyWrapper.scrollTop : 0
  for (let i = 0; i < personTextboxAll.length; i++) {
    if (personTextboxAll[i].querySelector('.person-textbox')) {
      if (that.typeFilterData === 'list') {
        if (personTextboxAll[i].offsetTop + 560 - tablieBodyScrollTop > h) {
          personTextboxAll[i].querySelector('.person-textbox').style.top = 'auto'
          personTextboxAll[i].querySelector('.person-textbox').style.bottom = '0'
        }
      } else {
        if (personTextboxAll[i].offsetLeft + 600 > w) {
          personTextboxAll[i].querySelector('.person-textbox').style.left =
            'auto'
          personTextboxAll[i].querySelector('.person-textbox').style.right =
            '90%'
        } else {
          personTextboxAll[i].querySelector('.person-textbox').style.left = '120px'
          personTextboxAll[i].querySelector('.person-textbox').style.right = 'auto'
        }
      }
    }
  }
}
</script>
<style lang="less" type="text/less">
  .del-doalog {
    width: 320px;
  }

  .icon-name_cont {
    position: relative;

    .invalid_flag {
      display: block;
      position: absolute;
      left: 10px;
      top: -3px;
      background-color: #7b7b7b;
      color: #fff;
      padding: 2px 5px;
      border-radius: 4px;
      z-index: 10;
    }
  }
</style>
<style lang="less" scoped>
  @import "~@/components/common/ProjectTable/Index.less";

  .listcnt {
    overflow: auto;
  }
</style>

